<template>
	<v-card class="pa-5 mb-4">
		<v-row no-gutters>
			<v-col cols="12">
				<v-row no-gutters align="center" style="min-height: 28px">
					<v-btn-toggle
						v-model="acuType"
						color="primary"
						mandatory
						class="mr-2"
						@change="channel = ''"
					>
						<v-btn
							value="classic"
							small
							key="classic"
							class="text-overline"
							:disabled="tan"
						>
							<translate>Classic</translate>
						</v-btn>
						<v-btn
							value="tung"
							small
							key="tung"
							class="text-overline"
							:disabled="tan"
						>
							Tung
						</v-btn>
					</v-btn-toggle>
					<template v-if="channel == ''">
						<span v-if="tan" class="ml-2 mx-4 font-weight-bold primary--text" key="tan">
							<translate>Balance Method</translate>
							<span class="mx-1">-</span>
							<span v-if="balanceType == 'local'" key="local">Local</span>
							<span v-else key="global">Global</span>
						</span>
						<span v-else class="ml-2 mx-4 font-weight-bold primary--text" v-translate key="channels">Channels</span>
					</template>
					<template v-else>
						<!-- <v-btn small @click="showPoints=false" icon color="primary">
									<v-icon>mdi-arrow-left</v-icon>
								</v-btn> -->
						<span
							class="ml-2 mx-4 font-weight-bold primary--text"
							key="channel"
							>{{ getChannelName(channel) }}</span
						>
						<v-spacer></v-spacer>
						<template v-if="channel != 'ashi'">
							<v-btn-toggle
								v-model="pointTechnics"
								mandatory
								class="mr-2"
								multiple
							>
								<v-btn
									:value="tec.id"
									small
									v-for="tec in technics"
									:key="tec.id"
									class="text-overline"
								>
									<v-icon class="mr-1" small color="primary">
										{{tec.icon}}
									</v-icon>
									{{ tec.name }}
								</v-btn>
							</v-btn-toggle>
						</template>
					</template>
					<v-spacer></v-spacer>
					<v-btn
						v-if="!tan"
						small
						class="text-overline"
						@click="acuType = 'classic'; channel = ''; tan = true;"
					>
						<v-icon color="primary" class="mr-1" small>mdi-scale-balance</v-icon>
						<translate>Balance M.</translate>
					</v-btn>
					<template v-else>
						<v-btn-toggle v-model="balanceType" color="primary" mandatory class="mr-2">
							<v-btn value="local" small key="local" class="text-overline">
								<translate>Local</translate>
							</v-btn>
							<v-btn value="global" small key="global" class="text-overline">
								Global
							</v-btn>
						</v-btn-toggle>
						<v-btn
							small
							@click="acuType = 'classic'; channel = ''; tan = false; resetTan()"
						>
							<v-icon color="primary" small>mdi-close</v-icon>
						</v-btn>
					</template>
				</v-row>
				<!-- <v-row no-gutters v-if="moxiSelected" class="mt-2">
							<v-spacer></v-spacer>
							<v-btn-toggle v-model="moxiCategory" mandatory class="mr-2">
								<v-btn value="direct" small key="direct" class="text-overline">
									<translate>Direct</translate>
								</v-btn>
								<v-btn value="indirect" small key="indirect" class="text-overline">
									<translate>Indirect</translate>
								</v-btn>
								<v-btn value="needle" small key="needle" class="text-overline">
									<translate>Needle</translate>
								</v-btn>
								<v-btn value="device" small key="device" class="text-overline">
									<translate>Device</translate>
								</v-btn>
							</v-btn-toggle>
						</v-row>
						<v-row no-gutters v-if="moxiSelected && moxiCategory == 'direct'" class="mt-2">
							<v-spacer></v-spacer>
							<v-btn-toggle v-model="directTechnic" mandatory class="mr-2">
								<v-btn value="bastao" small key="bastao" class="text-overline">
									Bastão (kobayashi-rouho)
								</v-btn>
								<v-btn value="grao" small key="grao" class="text-overline">
									Grão
								</v-btn>
								<v-btn value="gengibre" small key="gengibre" class="text-overline">
									Gengibre
								</v-btn>
								<v-btn value="other" small key="other" class="text-overline">
									Other
								</v-btn>
							</v-btn-toggle>
						</v-row> -->
			</v-col>
			<v-col cols="12">
				<v-divider class="my-4"></v-divider>
			</v-col>
			<template>
				<v-col style="min-width: 339px">
					<v-col v-for="(channelRow, numRow) in channelRows" :key="numRow" cols="12" class="pa-0 my-1">
						<v-row no-gutters justify="center">
							<div v-for="(chan, i) in channelRow" :key="chan.id + i">
								<v-btn
									:outlined="tan ? !existChannelTan(chan) : !existChannel(chan)"
									:width="numRow == 5 ? '135px' : '40px'"
									min-width="40px"
									:color="getChannelColor(chan)"
									:class="getButtonClasses(chan)"
									v-if="chan.id != 'fill'"
									depressed
									@click="selectChannel(chan)"
									@mouseover="chan.tanResult ? overResultChannel(chan) : null"
									@mouseleave="chan.tanResult ? leaveResultChannel(chan): null"
									elevation="2"
								>
									{{ getChannelInitials(chan.name) }}
									<span
										v-if="tan && chan.tanResult && chan.tanCovers.length > 1"
										style="position: absolute; top: -12px; right: 2px; height: 100%;"
										color="blue lighten-2"
										class="font-weight-bold text-caption">
										{{chan.tanCovers.length}}
									</span>
								</v-btn>
								<div class="mx-1" v-else style="width: 40px"></div>
								<v-btn v-if="numRow == 5 && i == 0" icon :disabled="acuPoints.length == 0 || saving" @click="showRemoveAllPoints = true">
									<v-icon color="primary">mdi-delete-alert</v-icon>
									<DeleteConfirmationDialog v-model="showRemoveAllPoints" item="points" @delete="removeAllPoints" />
								</v-btn>
							</div>
						</v-row>
					</v-col>
				</v-col>
				<v-col>
					<v-row no-gutters>
						<template v-if="channel == 'ashi'">
							<v-col cols="12">
								<SearchPoints @add-point="addAshiPoint" :auricular="auricular" :ashi="true" />
							</v-col>
							<v-col cols="12" class="my-2">
								<v-btn depressed small color="secondary" class="primary--text" :disabled="saving" @click="showNewPoint = true">
									<v-icon color="primary" small class="mr-1">mdi-plus-circle</v-icon>
									<span v-translate>Create Point</span>
								</v-btn>
							</v-col>
							<v-row no-gutters>
								<v-col class="pa-1">
									<v-textarea
										filled
										class="text-body-2"
										v-model="appointmentAshiPoints"
										hide-details
										@blur="saveAshi"
										:placeholder="$gettext('Notes')"
									></v-textarea>
								</v-col>
							</v-row>
						</template>
						<v-btn
							v-else
							:small="channel == 'ex' || channel == 'ex-central'"
							:width="
								channel == 'ex' || channel == 'ex-central' ? '140px' : '40px'
							"
							min-width="40px"
							class="mx-1 my-1"
							v-for="pt in points"
							:key="pt.id"
							:color="getPointColor(pt)"
							@click="clickPoint(pt)"
							depressed
							:disabled="saving"
							>{{ getNumber(pt) }}</v-btn
						>
					</v-row>
				</v-col>
			</template>
		</v-row>
		<v-row v-if="!tan" no-gutters align="center">
			<v-col class="pa-3">
				<v-row no-gutters>
					<v-select
						filled
						v-model="selectedTreatments"
						:items="customGroups"
						item-text="name"
						item-value="id"
						hide-details
						:label="$gettext('Treatment')"
						class="mr-1 text-caption"
						placeholder="Nenhum Tratamento Selecionado"
						:disabled="saving"
						no-data-text="Sem Tratamentos"
						multiple
					>
						<template slot="item" slot-scope="data">
							<v-list-item-content>
								<v-list-item-title>
									{{data.item.name}}
								</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action v-if="createMode" class="ma-0">
								<v-btn icon @click.stop="setGroupToEdit(data.item.id)" style="z-index: 300">
									<v-icon color="primary">mdi-cog</v-icon>
								</v-btn>
							</v-list-item-action>
						</template>
					</v-select>
				</v-row>
			</v-col>
			<v-col class="pa-3">
				<v-row no-gutters>
					<v-spacer></v-spacer>
					<v-btn icon @click="showSaveTreatment = !showSaveTreatment">
						<v-icon color="primary">mdi-content-save</v-icon>
					</v-btn>
				</v-row>
				<v-row no-gutters align="center">
					<v-spacer></v-spacer>
					<template v-if="showSaveTreatment">
						<span v-translate class="primary--text">Save treatment to use in the future</span>
						<v-btn color="secondary" class="primary--text ml-2" depressed @click="clickCreateGroup">
							<translate>Save Treatment</translate>
						</v-btn>
					</template>
					<v-dialog v-model="showNewGroup" max-width="40%" persistent scrollable>
						<v-card>
							<v-card-title class="text-subtitle-2 primary--text mb-2 secondary">
								<translate>New Treatment</translate>
							</v-card-title>
							<v-card-text>
								<v-form ref="newGroupForm">
									<v-text-field
										v-model="newGroup.name"
										:label="$gettext('Name')"
										filled
										:rules="[required]"
										class="text-caption"
									></v-text-field>
									<!-- <v-row no-gutters align="center" justify="center">
										<v-col cols="12">
											<v-color-picker v-model="newGroup.color" flat class="ma-2" hide-canvas hide-inputs></v-color-picker>
										</v-col>
									</v-row> -->
									<v-row no-gutters>
										<v-col cols="12">
											<span v-translate class="text-body-2 font-weight-bold">Points</span>
										</v-col>
										<v-col cols="12" class="mt-2">
											<SearchPoints @add-point="addPointToGroup($event, newGroup)" :auricular="auricular" />
											<p v-if="newGroup.points.length == 0" class="font-weight-thin ml-2 mt-2" v-translate>No points.</p>
											<AcuPointList v-else :list="newGroup.points" @remove-point="removePointFromGroup($event, newGroup)" />
										</v-col>
									</v-row>
								</v-form>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-btn small color="primary darken-1" text @click="showNewGroup = false">
									<translate>Cancel</translate>
								</v-btn>
								<v-spacer></v-spacer>
								<v-btn small color="primary darken-1" text @click="createGroup" :loading="saving">
									<translate>Create</translate>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
					<v-dialog v-model="showEditGroup" max-width="40%" persistent scrollable>
								<v-card v-if="groupToEdit">
									<v-card-title class="text-subtitle-2 primary--text mb-2 secondary">
										<translate>Edit Treatment</translate>
									</v-card-title>
									<v-card-text class="text-caption" v-if="groupToEdit">
										<v-form ref="groupForm">
											<v-text-field
												v-model="groupToEdit.name"
												:label="$gettext('Name')"
												filled
												:rules="[required]"
												class="text-caption"
											></v-text-field>
											<!-- <v-row no-gutters align="center" justify="center">
												<v-col cols="12">
													<v-color-picker v-model="groupToEdit.color" flat class="ma-2" hide-canvas hide-inputs></v-color-picker>
												</v-col>
											</v-row> -->
											<v-row no-gutters>
												<v-col cols="12">
													<span v-translate class="text-body-2 font-weight-bold">Points</span>
												</v-col>
												<v-col cols="12" class="mt-2">
													<SearchPoints @add-point="addPointToGroup($event, groupToEdit)" :auricular="auricular" />
													<p v-if="groupToEdit.points.length == 0" class="font-weight-thin ml-2" v-translate>No points.</p>
													<AcuPointList v-else :list="groupToEdit.points" @remove-point="removePointFromGroup($event, groupToEdit)" />
												</v-col>
											</v-row>
										</v-form>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions>
										<v-btn small color="primary" text @click="groupToEdit = null; showEditGroup = false">
											<translate>Cancel</translate>
										</v-btn>
										<v-spacer></v-spacer>
										<v-btn small color="primary" text @click="deleteGroup" :loading="saving">
											<v-icon class="mr-1">mdi-delete-circle</v-icon>
											<translate>Delete</translate>
										</v-btn>
										<v-btn small color="primary" text @click="editGroup" :loading="saving">
											<translate>Save</translate>
										</v-btn>
									</v-card-actions>
								</v-card>
					</v-dialog>
					<v-dialog v-model="showNewPoint" max-width="30%" persistent>
						<v-card>
							<v-card-title class="text-subtitle-2 primary--text mb-2 secondary">
								<translate>New Ashi Point</translate>
							</v-card-title>
							<v-card-text>
								<v-form ref="newPointForm">
									<v-text-field
										v-model="newPoint.name"
										:label="$gettext('Name')"
										filled
										:rules="[required]"
										class="text-caption"
									></v-text-field>
									<p v-if="pointExists" class="red--text">Já existe um ponto com este nome.</p>
								</v-form>
								<p><span v-translate class="font-weight-bold">Side</span> - {{quadrantName}}</p>
								<v-row no-gutters>
									<v-item-group mandatory v-model="newPoint.quadrant">
										<v-row no-gutters align="center">
											<v-item :value="1" v-slot:default="{ active, toggle }">
												<v-btn class="ma-1" small :key="1" :color="active ? 'primary' : 'secondary'" @click="toggle">
												</v-btn>
											</v-item>
											<v-item :value="5" v-slot:default="{ active, toggle }">
												<v-btn class="ma-1" small :key="5" :color="active ? 'primary' : 'secondary'" @click="toggle">
												</v-btn>
											</v-item>
											<v-item :value="2" v-slot:default="{ active, toggle }">
												<v-btn class="ma-1" small :key="2" :color="active ? 'primary' : 'secondary'" @click="toggle">
												</v-btn>
											</v-item>
										</v-row>
										<v-row no-gutters>
											<v-item :value="3" v-slot:default="{ active, toggle }">
												<v-btn class="ma-1" small :key="3" :color="active ? 'primary' : 'secondary'" @click="toggle">
												</v-btn>
											</v-item>
											<v-item :value="6" v-slot:default="{ active, toggle }">
												<v-btn class="ma-1" small :key="6" :color="active ? 'primary' : 'secondary'" @click="toggle">
												</v-btn>
											</v-item>
											<v-item :value="4" v-slot:default="{ active, toggle }">
												<v-btn class="ma-1" small :key="4" :color="active ? 'primary' : 'secondary'" @click="toggle">
												</v-btn>
											</v-item>
										</v-row>
									</v-item-group>
								</v-row>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-btn small color="primary darken-1" text @click="showNewPoint = false">
										<translate>Cancel</translate>
									</v-btn>
									<v-spacer></v-spacer>
									<v-btn small color="primary darken-1" text @click="createPoint">
										<translate>Create</translate>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
				</v-row>
			</v-col>
		</v-row>
		<v-row no-gutters v-if="tan" class="mt-4" align="center">
			<v-col cols="12">
				<v-stepper v-model="tanStep" non-linear>
					<v-stepper-header>
						<v-stepper-step
							:complete="tanStep > 1"
							step="1"
							:color="tanComplete ? 'green' : 'red lighten-2'"
							@click="tanStep = 1"
							:editable="tanStep > 1"
							edit-icon="$complete"
						>
							<translate>Affected Channels</translate>
						</v-stepper-step>

						<v-divider></v-divider>

						<v-stepper-step
							:complete="tanStep > 2"
							step="2"
							color="blue lighten-2"
							@click="tanStep > 2 ? tanStep = 2 : null"
							:editable="tanStep > 2"
							edit-icon="$complete"
						>
							<translate>Balance</translate>
						</v-stepper-step>

						<v-divider></v-divider>

						<v-stepper-step
							step="3"
							:complete="tanComplete"
						>
							<translate>Points</translate>
						</v-stepper-step>
					</v-stepper-header>
					<v-stepper-items>
						<v-stepper-content step="1" class="pa-1">
							<v-card
							>
								<v-card-text>
									<p v-if="balanceType == 'global'" class="font-weight-regular ml-2" v-translate>Select 2 channels</p>
									<!-- <p class="font-weight-thin ml-2" v-translate>Select the damaged channels.</p> -->
									<p v-if="tanSelectedChannels.length == 0" class="font-weight-thin ml-2" v-translate>No channels selected.</p>
									<v-chip v-for="channel in tanSelectedChannels" :key="channel.id + channel.position" outlined close @click:close="channel.tanSelected = false" :color="channelComplete(channel) ? 'green' : 'red lighten-2'" class="mr-1 mb-1">
										<span>{{getChannelInitials(channel.name)}}</span><span class="ml-1 font-weight-light">{{getChannelLaterality(channel.position)}}</span>
									</v-chip>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-btn
										color="secondary"
										depressed
										@click="restartTan"
										class="float-right primary--text"
										v-if="tanSelectedChannels.length > 0"
									>
										<translate>Restart</translate>
									</v-btn>
									<v-spacer></v-spacer>
									<v-btn
										color="secondary"
										depressed
										@click="nextStepTan"
										class="float-right primary--text"
										:disabled="balanceType == 'local' ? tanSelectedChannels.length == 0 : tanSelectedChannels.length != 2"
									>
										<span key="next" v-translate>Next</span>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-stepper-content>

						<v-stepper-content step="2" class="pa-1">
							<v-card>
								<v-card-text>
									<v-row no-gutters class="mb-3">
										<v-col cols="12" v-if="balanceType == 'local'">
											<span class="text-subtitle-1 mr-1 font-weight-thin" v-translate>Systems</span>
											<v-item-group multiple v-model="selectedSystems" class="mb-2" mandatory @change="recalculateTanLocal">
												<v-item v-for="n in 5" :key="n" v-slot="{ active, toggle }" :value="n">
													<v-chip color="green" :outlined="!active" @click="toggle" class="mr-1 mb-1">
														<span>{{getRomanNumber(n)}}</span>
													</v-chip>
												</v-item>
											</v-item-group>
										</v-col>
										<v-chip class="mr-1">1</v-chip>
										<v-chip 
											v-for="channel in tanSelectedChannels"
											:key="channel.id + channel.position"
											:outlined="channel.highlight ? false : true"
											:color="channel.highlight ? 'green' : channelCovered(channel) ? 'green' : 'red lighten-2'"
											class="mr-1 mb-1"
										>
											<v-icon v-if="channelComplete(channel)" small color="black" class="mr-1">mdi-check-circle</v-icon>
											<span>{{getChannelInitials(channel.name)}}</span><span class="ml-1 font-weight-light">{{getChannelLaterality(channel.position)}}</span>
										</v-chip>
									</v-row>
									<v-row no-gutters>
										<v-chip class="mr-1">2</v-chip>
										<v-chip
											v-for="channel in tanResultSelectedChannels"
											:key="channel.id + channel.position"
											:outlined="channel.tanSeletedResult ? false : true"
											color="blue lighten-2"
											class="mr-1 mb-1"
											@mouseover="overResultChannel(channel)"
											@mouseleave="leaveResultChannel(channel)"
											@click="clickResult(channel)"
										>
											<span>{{getChannelInitials(channel.name)}}</span>
											<span class="ml-1 font-weight-light">{{getChannelLaterality(channel.position)}}</span>
											<v-chip
												v-if="channel.tanCovers.length > 1"
												x-small
												color="blue lighten-2"
												:outlined="channel.tanSeletedResult ? false : true"
												class="font-weight-bold ml-1 pa-1">
												{{channel.tanCovers.length}}
											</v-chip>
										</v-chip>
									</v-row>
									<v-row no-gutters class="mt-2">
										<v-progress-linear v-model="coverageResults" height="20" reactive class="white--text" rounded>
											<strong>{{ Math.ceil(coverageResults) }}%</strong>
										</v-progress-linear>
									</v-row>
									<v-row no-gutters align="center" class="mt-4">
										<span v-translate class="blue--text">Select the balance channels to cover all the affected channels.</span>
									</v-row>
									<v-row no-gutters align="center" class="mt-2">
										<span v-translate class="ml-1">Suggestions</span>
									</v-row>
									<v-row no-gutters class="mt-2" align="center">
										<p v-if="tanSolutionsOrdered.length == 0" class="font-weight-thin ml-2" v-translate>No suggestions.</p>
										<v-col v-for="(solution , i) in tanSolutionsOrdered" :key="i" cols="6">
											<v-chip x-small outlined class="pa-1 mb-1 mr-2" @click="addResult(solution)">{{i + 1}}</v-chip>
											<v-chip
												v-for="channel in solution"
												:key="channel.id + channel.position"
												:outlined="channel.tanSeletedResult ? false : true"
												color="blue lighten-2"
												class="mr-1 mb-1"
												@mouseover="overResultChannel(channel)"
												@mouseleave="leaveResultChannel(channel)"
												@click="clickResult(channel)"
											>
												<span>{{getChannelInitials(channel.name)}}</span>
												<span class="ml-1 font-weight-light">{{getChannelLaterality(channel.position)}}</span>
												<v-chip
													v-if="channel.tanCovers.length > 1"
													x-small
													color="blue lighten-2"
													:outlined="channel.tanSeletedResult ? false : true"
													class="font-weight-bold ml-1 pa-1">
													{{channel.tanCovers.length}}
												</v-chip>
											</v-chip>
											<v-chip v-if="balanceType == 'global'" x-small outlined class="pa-1 mb-1 mr-2">{{tanSolutionsStructures[i]}}</v-chip>
										</v-col>
									</v-row>
									<v-row no-gutters align="center" class="mt-2">
										<span v-translate class="ml-1">Note</span>:<span class="font-weight-thin ml-1" v-translate>The presented sugestions are optimized to use the minimal group of balance channels to cover all the affected channels and are ordered by weight.</span>
									</v-row>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-btn
										color="secondary"
										depressed
										@click="restartTan"
										class="float-right primary--text"
									>
										<translate>Restart</translate>
									</v-btn>
									<v-spacer></v-spacer>
									<v-btn
										depressed
										color="secondary"
										@click="nextStepTan"
										class="float-right primary--text"
										:disabled="tanResultSelectedChannels.length == 0"
									>
										<span key="finish" v-if="tanStep == 3" v-translate>Finish</span>
										<span key="next" v-else v-translate>Next</span>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-stepper-content>

						<v-stepper-content step="3" class="pa-1">
							<v-card>
								<v-card-text>
									<v-row no-gutters class="mb-3">
										<v-chip class="mr-1">1</v-chip>
										<v-chip
											v-for="channel in tanSelectedChannels"
											:key="channel.id + channel.position"
											:outlined="channel.highlight ? false : channelComplete(channel) ? false : true"
											:color="channel.highlight ? 'green' : channelCovered(channel) ? 'green' : 'red lighten-2'"
											class="mr-1 mb-1"
										>
											<v-icon v-if="channelComplete(channel)" small color="black" class="mr-1">mdi-check-circle</v-icon>
											<span>{{getChannelInitials(channel.name)}}</span><span class="ml-1 font-weight-light">{{getChannelLaterality(channel.position)}}</span>
										</v-chip>
									</v-row>
									<v-row no-gutters>
										<v-chip class="mr-1">2</v-chip>
										<v-chip
											v-for="channel in tanResultSelectedChannels"
											:key="channel.id + channel.position"
											color="blue lighten-2"
											class="mr-1 mb-1"
											@mouseover="overResultChannel(channel)"
											@mouseleave="leaveResultChannel(channel)"
											@click="selectChannel(channel)"
										>
											<span>{{getChannelInitials(channel.name)}}</span>
											<span class="ml-1 font-weight-light">{{getChannelLaterality(channel.position)}}</span>
											<v-chip x-small v-if="channel.tanCovers.length > 1" color="blue lighten-2" class="font-weight-bold ml-1 pa-1">{{channel.tanCovers.length}}</v-chip>
										</v-chip>
									</v-row>
									<v-row no-gutters align="center" class="mt-2">
										<v-chip class="mr-1">3</v-chip>
										<span class="primary--text ml-1" v-translate>Select points that belong to the balance channels.</span>
									</v-row>
									<v-row no-gutters class="mt-2">
										<v-progress-linear v-model="coveragePoints" height="20" reactive class="white--text" rounded>
											<strong>{{ Math.ceil(coveragePoints) }}%</strong>
										</v-progress-linear>
									</v-row>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-btn
										color="secondary"
										depressed
										@click="restartTan"
										class="float-right primary--text"
									>
										<translate>Restart</translate>
									</v-btn>
									<v-spacer></v-spacer>
									<v-btn
										color="secondary"
										depressed
										@click="nextStepTan"
										class="float-right primary--text"
									>
										<span key="finish" v-if="tanStep == 3" v-translate>Finish</span>
										<span key="next" v-else v-translate>Next</span>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-stepper-content>
					</v-stepper-items>
				</v-stepper>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import AcuPointList from "@/components/acupuncture/AcuPointList.vue";
import SearchPoints from "@/components/appointment/treatments/tcm/acupuncture/SearchPoints.vue";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import { mapGetters } from 'vuex'

export default {
	name: "AcupunctureSelector",
  props: {
		auricular: {
			default: false
		},
		createMode: {
			default: false
		}
	},
	components: {
		AcuPointList,
		SearchPoints,
		DeleteConfirmationDialog
	},
  data: () => ({
		selectedTreatments: [],
		acuType: 'classic',
		balanceType: 'local',
		selectedSystems: [1, 2, 3, 4, 5],
		tanSolutionsStructures: [],
		tan: false,
		tanStep: 1,
		tanSolutions: [],
		channel: "",
		point: "",
		position: "",
		showSaveTreatment: false,
		showRemoveAllPoints: false,
		showNewPoint: false,
		pointExists: false,
		newPoint: {
			name: "",
			cx: null,
			cy: null,
			side: "left",
			quadrant: 1,
			ashi: true
		},
		showNewGroup: false,
		newGroup: {
			name: "",
			//color: "",
			custom: true,
			points: [],
			ashi_points: ""
		},
		showEditGroup: false,
		groupToEdit: null,
		tanMatrix: {
			"lu": ["sp", "bl", "li", "bl", "liv"],
			"li": ["st", "liv", "lu", "kd", "st"],
			"st": ["li", "pc", "sp", "pc", "li"],
			"sp": ["lu", "si", "st", "sj", "he"],
			"he": ["kd", "gb", "si", "gb", "sp"],
			"si": ["bl", "sp", "he", "liv", "bl"],
			"bl": ["si", "lu", "kd", "lu", "si"],
			"kd": ["he", "sj", "bl", "li", "pc"],
			"pc": ["liv", "st", "sj", "st", "kd"],
			"sj": ["gb", "kd", "pc", "sp", "gb"],
			"gb": ["sj", "he", "liv", "he", "sj"],
			"liv": ["pc", "li", "gb", "si", "lu"],
			"ren": ["du"],
			"du": ["ren"],
		},
		channelsRowOne: [
			{ id: "lu", name: "LU", color: "primary lighten-2", quadrant: 1, positive: false, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "pc", name: "PC", color: "primary lighten-2", quadrant: 1, positive: false, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "he", name: "HE", color: "primary lighten-2", quadrant: 1, positive: false, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "fill" },
			{ id: "he", name: "HE", color: "primary lighten-2", quadrant: 2, positive: false, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "pc", name: "PC", color: "primary lighten-2", quadrant: 2, positive: false, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "lu", name: "LU", color: "primary lighten-2", quadrant: 2, positive: false, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false }
		],
		channelsRowTwo: [
			{ id: "li", name: "LI", color: "primary lighten-2", quadrant: 1, positive: true, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "sj", name: "SJ", color: "primary lighten-2", quadrant: 1, positive: true, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "si", name: "SI", color: "primary lighten-2", quadrant: 1, positive: true, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "du", name: "DU", color: "primary", position: "center", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "si", name: "SI", color: "primary lighten-2", quadrant: 2, positive: true, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "sj", name: "SJ", color: "primary lighten-2", quadrant: 2, positive: true, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "li", name: "LI", color: "primary lighten-2", quadrant: 2, positive: true, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false }
		],
		channelsRowThree: [
			{ id: "sp", name: "SP", color: "primary darken-2", quadrant: 4, positive: false, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "liv", name: "LIV", color: "primary darken-2", quadrant: 4, positive: false, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "kd", name: "KD", color: "primary darken-2", quadrant: 4, positive: false, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "ren", name: "REN", color: "primary darken-2", position: "center", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "kd", name: "KD", color: "primary darken-2", quadrant: 3, positive: false, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "liv", name: "LIV", color: "primary darken-2", quadrant: 3, positive: false, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "sp", name: "SP", color: "primary darken-2", quadrant: 3, positive: false, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false }
		],
		channelsRowFour: [
			{ id: "st", name: "ST", color: "primary darken-2", quadrant: 4, positive: true, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "gb", name: "GB", color: "primary darken-2", quadrant: 4, positive: true, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "bl", name: "BL", color: "primary darken-2", quadrant: 4, positive: true, position: "right", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "fill" },
			{ id: "bl", name: "BL", color: "primary darken-2", quadrant: 3, positive: true, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "gb", name: "GB", color: "primary darken-2", quadrant: 3, positive: true, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false },
			{ id: "st", name: "ST", color: "primary darken-2", quadrant: 3, positive: true, position: "left", tanSelected: false, tanCovers: [], tanCovered: [], tanResult: 0, tanSeletedResult: false, highlight: false }
		],
		channelsRowFive: [
			{ id: "fill" },
			{ id: "fill" },
			{ id: "ex", name: "EX", color: "primary darken-2", position: "right" },
			{ id: "ex-central", name: "EX", color: "primary darken-2", position: "center" },
			{ id: "ex", name: "EX", color: "primary darken-2", position: "left" },
			{ id: "fill" },
			{ id: "fill" }
		],
		channelsRowSix: [
			{ id: "fill" },
			{ id: "fill" },
			{ id: "ashi", name: "ASHI", color: "primary darken-2", position: "center" },
			{ id: "fill" },
			{ id: "fill" }
		],
		channelsRowOneTung: [
			{ id: "fill" },
			{ id: "99", name: "9", color: "primary darken-2", position: "right" },
			{ id: "1010", name: "10", color: "primary darken-2", position: "right" },
			{ id: "1010-central", name: "10", color: "primary darken-2", position: "center" },
			{ id: "1010", name: "10", color: "primary darken-2", position: "left" },
			{ id: "99", name: "9", color: "primary darken-2", position: "left" },
			{ id: "fill" }
		],
		channelsRowTwoTung: [
			{ id: "11", name: "1", color: "primary darken-2", position: "right" },
			{ id: "44", name: "4", color: "primary darken-2", position: "right" },
			{ id: "dt", name: "DT", color: "primary darken-2", position: "right" },
			{ id: "dt-central", name: "DT", color: "primary darken-2", position: "center" },
			{ id: "dt", name: "DT", color: "primary darken-2", position: "left" },
			{ id: "44", name: "4", color: "primary darken-2", position: "left" },
			{ id: "11", name: "1", color: "primary darken-2", position: "left" }
		],
		channelsRowThreeTung: [
			{ id: "22", name: "2", color: "primary darken-2", position: "right" },
			{ id: "33", name: "3", color: "primary darken-2", position: "right" },
			{ id: "fill" },
			{ id: "vt-central", name: "VT", color: "primary darken-2", position: "center" },
			{ id: "fill" },
			{ id: "33", name: "3", color: "primary darken-2", position: "left" },
			{ id: "22", name: "2", color: "primary darken-2", position: "left" }
		],
		channelsRowFourTung: [
			{ id: "fill" },
			{ id: "66", name: "6", color: "primary darken-2", position: "right" },
			{ id: "77", name: "7", color: "primary darken-2", position: "right" },
			{ id: "fill" },
			{ id: "77", name: "7", color: "primary darken-2", position: "left" },
			{ id: "66", name: "6", color: "primary darken-2", position: "left" },
			{ id: "fill" }
		],
		channelsRowFiveTung: [
			{ id: "fill" },
			{ id: "55", name: "5", color: "primary darken-2", position: "right" },
			{ id: "88", name: "8", color: "primary darken-2", position: "right" },
			{ id: "fill" },
			{ id: "88", name: "8", color: "primary darken-2", position: "left" },
			{ id: "55", name: "5", color: "primary darken-2", position: "left" },
			{ id: "fill" }
		],
		appointmentAshiPoints: null,
		moxiCategory: "direct",
		directTechnic: "bastao",
		indirectTechnic: "salt",
		needleTechnic: "needle",
		deviceTechnic: "box",
		pointTechnics: [1],
		CENTRAL_CHANNELS: ["ren", "du", "ex-central"],
		LU_POINTS: [
			{ id: "lu-1", name: "LU-1 (Zhōng Fǔ)" },
			{ id: "lu-2", name: "LU-2 (Yún Mén)" },
			{ id: "lu-3", name: "LU-3 (Tiān Fǔ)" },
			{ id: "lu-4", name: "LU-4 (Xiá Bái)" },
			{ id: "lu-5", name: "LU-5 (Chǐ Zé)" },
			{ id: "lu-6", name: "LU-6 (Kǒng Zuì)" },
			{ id: "lu-7", name: "LU-7 (Liè Quē)" },
			{ id: "lu-8", name: "LU-8 (Jīng Qú)" },
			{ id: "lu-9", name: "LU-9 (Tài Yuān)" },
			{ id: "lu-10", name: "LU-10 (Yú Jì)" },
			{ id: "lu-11", name: "LU-11 (Shào Shāng)" }
		],
		LI_POINTS: [
			{ id: "li-1", name: "LI-1 (Shāng Yáng)" },
			{ id: "li-2", name: "LI-2 (Èr Jiān)" },
			{ id: "li-3", name: "LI-3 (Sān Jiān)" },
			{ id: "li-4", name: "LI-4 (Hé Gǔ)" },
			{ id: "li-5", name: "LI-5 (Yáng Xī)" },
			{ id: "li-6", name: "LI-6 (Piān Lì)" },
			{ id: "li-7", name: "LI-7 (Wēn Liū)" },
			{ id: "li-8", name: "LI-8 (Xià Lián)" },
			{ id: "li-9", name: "LI-9 (Shàng Lián)" },
			{ id: "li-10", name: "LI-10 (Shǒu Sān Lǐ)" },
			{ id: "li-11", name: "LI-11 (Qū Chí)" },
			{ id: "li-12", name: "LI-12 (Zhǒu Liáo)" },
			{ id: "li-13", name: "LI-13 (Shǒu Wǔ Lǐ)" },
			{ id: "li-14", name: "LI-14 (Bì Nào)" },
			{ id: "li-15", name: "LI-15 (Jiān Yú)" },
			{ id: "li-16", name: "LI-16 (Jù Gǔ)" },
			{ id: "li-17", name: "LI-17 (Tiān Dǐng)" },
			{ id: "li-18", name: "LI-18 (Fú Tū)" },
			{ id: "li-19", name: "LI-19 (Kǒu Hé Liáo)" },
			{ id: "li-20", name: "LI-20 (Yíng Xiāng)" }
		],
		ST_POINTS: [
			{ id: "st-1", name: "ST-1 (Chéng Qì)" },
			{ id: "st-2", name: "ST-2 (Sì Bái)" },
			{ id: "st-3", name: "ST-3 (Jù Liáo)" },
			{ id: "st-4", name: "ST-4 (Dì Cāng)" },
			{ id: "st-5", name: "ST-5 (Dà Yíng)" },
			{ id: "st-6", name: "ST-6 (Jiá Chē)" },
			{ id: "st-7", name: "ST-7 (Xià Guān)" },
			{ id: "st-8", name: "ST-8 (Tóu Wéi)" },
			{ id: "st-9", name: "ST-9 (Rén Yíng)" },
			{ id: "st-10", name: "ST-10 (Shǔi Tū)" },
			{ id: "st-11", name: "ST-11 (Qì Shè)" },
			{ id: "st-12", name: "ST-12 (Quē Pén)" },
			{ id: "st-13", name: "ST-13 (Qì Hù)" },
			{ id: "st-14", name: "ST-14 (Kù Fáng)" },
			{ id: "st-15", name: "ST-15 (Wū Yì)" },
			{ id: "st-16", name: "ST-16 (Yìng Chuāng)" },
			{ id: "st-17", name: "ST-17 (Rǔ Zhōng)" },
			{ id: "st-18", name: "ST-18 (Rǔ Gēn)" },
			{ id: "st-19", name: "ST-19 (Bù Róng)" },
			{ id: "st-20", name: "ST-20 (Chéng Mǎn)" },
			{ id: "st-21", name: "ST-21 (Liáng Mén)" },
			{ id: "st-22", name: "ST-22 (Guān Mén)" },
			{ id: "st-23", name: "ST-23 (Tài Yǐ)" },
			{ id: "st-24", name: "ST-24 (Huá Ròu Mén)" },
			{ id: "st-25", name: "ST-25 (Tiān Shū)" },
			{ id: "st-26", name: "ST-26 (Wài Líng)" },
			{ id: "st-27", name: "ST-27 (Dà Jù)" },
			{ id: "st-28", name: "ST-28 (Shuǐ Dào)" },
			{ id: "st-29", name: "ST-29 (Guī Lái)" },
			{ id: "st-30", name: "ST-30 (Qì Chōng)" },
			{ id: "st-31", name: "ST-31 (Bì Guān)" },
			{ id: "st-32", name: "ST-32 (Fú Tù)" },
			{ id: "st-33", name: "ST-33 (Yīn Shì)" },
			{ id: "st-34", name: "ST-34 (Liáng Qīu)" },
			{ id: "st-35", name: "ST-35 (Dú Bí)" },
			{ id: "st-36", name: "ST-36 (Zú Sān Lǐ)" },
			{ id: "st-37", name: "ST-37 (Shàng Jù Xū)" },
			{ id: "st-38", name: "ST-38 (Tiáo Kǒu)" },
			{ id: "st-39", name: "ST-39 (Xià Jù Xū)" },
			{ id: "st-40", name: "ST-40 (Fēng Lóng)" },
			{ id: "st-41", name: "ST-41 (Jiě Xī)" },
			{ id: "st-42", name: "ST-42 (Chōng Yáng)" },
			{ id: "st-43", name: "ST-43 (Xiàn Gǔ)" },
			{ id: "st-44", name: "ST-44 (Nèi Tíng)" },
			{ id: "st-45", name: "ST-45 (Lì Duì)" }
		],
		SP_POINTS: [
			{ id: "sp-1", name: "SP-1 (Chéng Qì)" },
			{ id: "sp-2", name: "SP-2 (Dà Dū)" },
			{ id: "sp-3", name: "SP-3 (Taì Bái)" },
			{ id: "sp-4", name: "SP-4 (Gōng Sūn)" },
			{ id: "sp-5", name: "SP-5 (Shāng Qiū)" },
			{ id: "sp-6", name: "SP-6 (Sān Yīn Jiāo)" },
			{ id: "sp-7", name: "SP-7 (Loù Gǔ)" },
			{ id: "sp-8", name: "SP-8 (Dì Jī)" },
			{ id: "sp-9", name: "SP-9 (Yīn Líng Qúan)" },
			{ id: "sp-10", name: "SP-10 (Xuè Hǎi)" },
			{ id: "sp-11", name: "SP-11 (Jī Mén)" },
			{ id: "sp-12", name: "SP-12 (Chōng Mén)" },
			{ id: "sp-13", name: "SP-13 (Fǔ Shè)" },
			{ id: "sp-14", name: "SP-14 (Fù Jié)" },
			{ id: "sp-15", name: "SP-15 (Dà Héng)" },
			{ id: "sp-16", name: "SP-16 (Fù Āi)" },
			{ id: "sp-17", name: "SP-17 (Shí Dòu)" },
			{ id: "sp-18", name: "SP-18 (Tiān Xī)" },
			{ id: "sp-19", name: "SP-19 (Xiōng Xiāng)" },
			{ id: "sp-20", name: "SP-20 (Zhōu Róng)" },
			{ id: "sp-21", name: "SP-21 (Dà Bāo)" }
		],
		HE_POINTS: [
			{ id: "he-1", name: "HE-1 (Jí Quán)" },
			{ id: "he-2", name: "HE-2 (Qīng Líng)" },
			{ id: "he-3", name: "HE-3 (Shào Hǎi)" },
			{ id: "he-4", name: "HE-4 (Líng Dào)" },
			{ id: "he-5", name: "HE-5 (Tōng Lǐ)" },
			{ id: "he-6", name: "HE-6 (Yīn Xī)" },
			{ id: "he-7", name: "HE-7 (Shén Mén)" },
			{ id: "he-8", name: "HE-8 (Shào Fǔ)" },
			{ id: "he-9", name: "HE-9 (Shào Chōng)" }
		],
		SI_POINTS: [
			{ id: "si-1", name: "SI-1 (Shào Zé)" },
			{ id: "si-2", name: "SI-2 (Qián Gǔ)" },
			{ id: "si-3", name: "SI-3 (Hòu Xī)" },
			{ id: "si-4", name: "SI-4 (Wàn Gǔ)" },
			{ id: "si-5", name: "SI-5 (Yáng Gǔ)" },
			{ id: "si-6", name: "SI-6 (Yǎng Lǎo)" },
			{ id: "si-7", name: "SI-7 (Zhī Zhèng)" },
			{ id: "si-8", name: "SI-8 (Xiǎo Hǎi)" },
			{ id: "si-9", name: "SI-9 (Jiān Zhēn)" },
			{ id: "si-10", name: "SI-10 (Nāo Shū)" },
			{ id: "si-11", name: "SI-11 (Tiān Zōng)" },
			{ id: "si-12", name: "SI-12 (Bǐng Fēng)" },
			{ id: "si-13", name: "SI-13 (Qū Yuán)" },
			{ id: "si-14", name: "SI-14 (Jiān Wài Shū)" },
			{ id: "si-15", name: "SI-15 (Jiān Zhōng Shū)" },
			{ id: "si-16", name: "SI-16 (Tiān Chuāng)" },
			{ id: "si-17", name: "SI-17 (Tiān Róng)" },
			{ id: "si-18", name: "SI-18 (Quán Liáo)" },
			{ id: "si-19", name: "SI-19 (Tīng Gōng)" }
		],
		BL_POINTS: [
			{ id: "bl-1", name: "BL-1 (Jīng Míng)" },
			{ id: "bl-2", name: "BL-2 (Cuán Zhú)" },
			{ id: "bl-3", name: "BL-3 (Méi Chōng)" },
			{ id: "bl-4", name: "BL-4 (Qǔ Chā)" },
			{ id: "bl-5", name: "BL-5 (Wǔ Chǔ)" },
			{ id: "bl-6", name: "BL-6 (Chéng Guāng)" },
			{ id: "bl-7", name: "BL-7 (Tōng Tiān)" },
			{ id: "bl-8", name: "BL-8 (Luò Què)" },
			{ id: "bl-9", name: "BL-9 (Yù Zhěn)" },
			{ id: "bl-10", name: "BL-10 (Tiān Zhù)" },
			{ id: "bl-11", name: "BL-11 (Dà Zhù)" },
			{ id: "bl-12", name: "BL-12 (Fēng Mén)" },
			{ id: "bl-13", name: "BL-13 (Fèi Shū)" },
			{ id: "bl-14", name: "BL-14 (Jué Yīn Shū)" },
			{ id: "bl-15", name: "BL-15 (Xīn Shū)" },
			{ id: "bl-16", name: "BL-16 (Dū Shū)" },
			{ id: "bl-17", name: "BL-17 (Gé Shū)" },
			{ id: "bl-18", name: "BL-18 (Gān Shū)" },
			{ id: "bl-19", name: "BL-19 (Dǎn Shū)" },
			{ id: "bl-20", name: "BL-20 (Pí Shū)" },
			{ id: "bl-21", name: "BL-21 (Wèi Shū)" },
			{ id: "bl-22", name: "BL-22 (Sān Jiāo Shū)" },
			{ id: "bl-23", name: "BL-23 (Shèn Shū)" },
			{ id: "bl-24", name: "BL-24 (Qì Hǎi Shū)" },
			{ id: "bl-25", name: "BL-25 (Dà Cháng Shū)" },
			{ id: "bl-26", name: "BL-26 (Guān Yuán Shū)" },
			{ id: "bl-27", name: "BL-27 (Xiǎo Cháng Shū)" },
			{ id: "bl-28", name: "BL-28 (Páng Guāng Shū)" },
			{ id: "bl-29", name: "BL-29 (Zhōng Lǚ Shū)" },
			{ id: "bl-30", name: "BL-30 (Bái Huán Shū)" },
			{ id: "bl-31", name: "BL-31 (Shàng Liáo)" },
			{ id: "bl-32", name: "BL-32 (Cì Liáo)" },
			{ id: "bl-33", name: "BL-33 (Zhōng Liáo)" },
			{ id: "bl-34", name: "BL-34 (Xià Liáo)" },
			{ id: "bl-35", name: "BL-35 (Huì Yáng)" },
			{ id: "bl-36", name: "BL-36 (Chéng Fú)" },
			{ id: "bl-37", name: "BL-37 (Yīn Mén)" },
			{ id: "bl-38", name: "BL-38 (Fú Xī)" },
			{ id: "bl-39", name: "BL-39 (Wěi Yáng)" },
			{ id: "bl-40", name: "BL-40 (Wěi Zhōng)" },
			{ id: "bl-41", name: "BL-41 (Fù Fēn)" },
			{ id: "bl-42", name: "BL-42 (Pò Hù)" },
			{ id: "bl-43", name: "BL-43 (Gāo Huāng Shū)" },
			{ id: "bl-44", name: "BL-44 (Shén Táng)" },
			{ id: "bl-45", name: "BL-45 (Yì Xǐ)" },
			{ id: "bl-46", name: "BL-46 (Gé Guān)" },
			{ id: "bl-47", name: "BL-47 (Hún Mén)" },
			{ id: "bl-48", name: "BL-48 (Yáng Gāng)" },
			{ id: "bl-49", name: "BL-49 (Yì Shě)" },
			{ id: "bl-50", name: "BL-50 (Wèi Cāng)" },
			{ id: "bl-51", name: "BL-51 (Huāng Mén)" },
			{ id: "bl-52", name: "BL-52 (Zhì Shì)" },
			{ id: "bl-53", name: "BL-53 (Bāo Huāng)" },
			{ id: "bl-54", name: "BL-54 (Zhì Biān)" },
			{ id: "bl-55", name: "BL-55 (Hé Yáng)" },
			{ id: "bl-56", name: "BL-56 (Chéng Jīn)" },
			{ id: "bl-57", name: "BL-57 (Chéng Shān)" },
			{ id: "bl-58", name: "BL-58 (Fēi Yáng)" },
			{ id: "bl-59", name: "BL-59 (Fū Yáng)" },
			{ id: "bl-60", name: "BL-60 (Kūn Lún)" },
			{ id: "bl-61", name: "BL-61 (Pú Cān)" },
			{ id: "bl-62", name: "BL-62 (Shēn Mài)" },
			{ id: "bl-63", name: "BL-63 (Jīn Mén)" },
			{ id: "bl-64", name: "BL-64 (Jīng Gǔ)" },
			{ id: "bl-65", name: "BL-65 (Shù Gǔ)" },
			{ id: "bl-66", name: "BL-66 (Zú Tōng Gǔ)" },
			{ id: "bl-67", name: "BL-67 (Zhì Yīn)" }
		],
		KD_POINTS: [
			{ id: "kd-1", name: "KD-1 (Yǒng Quán)" },
			{ id: "kd-2", name: "KD-2 (Rán Gǔ)" },
			{ id: "kd-3", name: "KD-3 (Taì Xī)" },
			{ id: "kd-4", name: "KD-4 (Dà Zhōng)" },
			{ id: "kd-5", name: "KD-5 (Shuǐ Quán)" },
			{ id: "kd-6", name: "KD-6 (Zhào Hǎi)" },
			{ id: "kd-7", name: "KD-7 (Fù Liū)" },
			{ id: "kd-8", name: "KD-8 (Jiāo Xìn)" },
			{ id: "kd-9", name: "KD-9 (Zhú Bīn)" },
			{ id: "kd-10", name: "KD-10 (Yīn Gǔ)" },
			{ id: "kd-11", name: "KD-11 (Héng Gǔ)" },
			{ id: "kd-12", name: "KD-12 (Dà Hè)" },
			{ id: "kd-13", name: "KD-13 (Qì Xué)" },
			{ id: "kd-14", name: "KD-14 (Sì Mǎn)" },
			{ id: "kd-15", name: "KD-15 (Zhōng Zhù)" },
			{ id: "kd-16", name: "KD-16 (Huāng Shū)" },
			{ id: "kd-17", name: "KD-17 (Shāng Qū)" },
			{ id: "kd-18", name: "KD-18 (Shí Guān)" },
			{ id: "kd-19", name: "KD-19 (Yīn Dū)" },
			{ id: "kd-20", name: "KD-20 (Fù Tōng Gǔ)" },
			{ id: "kd-21", name: "KD-21 (Yōu Mén)" },
			{ id: "kd-22", name: "KD-22 (Bù Láng)" },
			{ id: "kd-23", name: "KD-23 (Shén Fēng)" },
			{ id: "kd-24", name: "KD-24 (Líng Xū)" },
			{ id: "kd-25", name: "KD-25 (Shén Cáng)" },
			{ id: "kd-26", name: "KD-26 (Yù Zhōng)" },
			{ id: "kd-27", name: "KD-27 (Shū Fǔ)" }
		],
		PC_POINTS: [
			{ id: "pc-1", name: "PC-1 (Tiān Chí)" },
			{ id: "pc-2", name: "PC-2 (Tiān Quán)" },
			{ id: "pc-3", name: "PC-3 (Qū Zé)" },
			{ id: "pc-4", name: "PC-4 (Xī Mén)" },
			{ id: "pc-5", name: "PC-5 (Jiān Shǐ)" },
			{ id: "pc-6", name: "PC-6 (Nèi Guān)" },
			{ id: "pc-7", name: "PC-7 (Dà Líng)" },
			{ id: "pc-8", name: "PC-8 (Láo Gōng)" },
			{ id: "pc-9", name: "PC-9 (Zhōng Chōng)" }
		],
		SJ_POINTS: [
			{ id: "sj-1", name: "SJ-1 (Guān Chōng)" },
			{ id: "sj-2", name: "SJ-2 (Yè Mén)" },
			{ id: "sj-3", name: "SJ-3 (Zhōng Zhǔ)" },
			{ id: "sj-4", name: "SJ-4 (Yáng Chí)" },
			{ id: "sj-5", name: "SJ-5 (Wài Guān)" },
			{ id: "sj-6", name: "SJ-6 (Zhī Gōu)" },
			{ id: "sj-7", name: "SJ-7 (Huì Zōng)" },
			{ id: "sj-8", name: "SJ-8 (Sān Yáng Luò)" },
			{ id: "sj-9", name: "SJ-9 (Sì Dú)" },
			{ id: "sj-10", name: "SJ-10 (Tiān Jǐng)" },
			{ id: "sj-11", name: "SJ-11 (Qīng Lěng Yuān)" },
			{ id: "sj-12", name: "SJ-12 (Xiāo Luò)" },
			{ id: "sj-13", name: "SJ-13 (Nào Huì)" },
			{ id: "sj-14", name: "SJ-14 (Jiān Liáo)" },
			{ id: "sj-15", name: "SJ-15 (Tiān Liáo)" },
			{ id: "sj-16", name: "SJ-16 (Tiān Yǒu)" },
			{ id: "sj-17", name: "SJ-17 (Yì Fēng)" },
			{ id: "sj-18", name: "SJ-18 (Qì Mài)" },
			{ id: "sj-19", name: "SJ-19 (Lú Xī)" },
			{ id: "sj-20", name: "SJ-20 (Jiǎo Sūn)" },
			{ id: "sj-21", name: "SJ-21 (Ěr Mén)" },
			{ id: "sj-22", name: "SJ-22 (Ěr Hé Liáo)" },
			{ id: "sj-23", name: "SJ-23 (Sī Zhú Kōng)" }
		],
		GB_POINTS: [
			{ id: "gb-1", name: "GB-1 (Tóng Zǐ Liáo)" },
			{ id: "gb-2", name: "GB-2 (Tīng Huì)" },
			{ id: "gb-3", name: "GB-3 (Shàng Guān)" },
			{ id: "gb-4", name: "GB-4 (Hàn Yàn)" },
			{ id: "gb-5", name: "GB-5 (Xuán Lú)" },
			{ id: "gb-6", name: "GB-6 (Xuán Lí)" },
			{ id: "gb-7", name: "GB-7 (Qū Bìn)" },
			{ id: "gb-8", name: "GB-8 (Shuài Gǔ)" },
			{ id: "gb-9", name: "GB-9 (Tiān Chōng)" },
			{ id: "gb-10", name: "GB-10 (Fú Bái)" },
			{ id: "gb-11", name: "GB-11 (Tóu Qiào Yīn)" },
			{ id: "gb-12", name: "GB-12 (Wán Gǔ)" },
			{ id: "gb-13", name: "GB-13 (Běn Shén)" },
			{ id: "gb-14", name: "GB-14 (Yáng Bái)" },
			{ id: "gb-15", name: "GB-15 (Tóu Lín Qì)" },
			{ id: "gb-16", name: "GB-16 (Mù Chuāng)" },
			{ id: "gb-17", name: "GB-17 (Zhèng Yíng)" },
			{ id: "gb-18", name: "GB-18 (Chéng Líng)" },
			{ id: "gb-19", name: "GB-19 (Nǎo Kōng)" },
			{ id: "gb-20", name: "GB-20 (Fēng Chí)" },
			{ id: "gb-21", name: "GB-21 (Jīan Jǐng)" },
			{ id: "gb-22", name: "GB-22 (Yuān Yè)" },
			{ id: "gb-23", name: "GB-23 (Zhé Jīn)" },
			{ id: "gb-24", name: "GB-24 (Rì Yuè)" },
			{ id: "gb-25", name: "GB-25 (Jīng Mén)" },
			{ id: "gb-26", name: "GB-26 (Dài Mài)" },
			{ id: "gb-27", name: "GB-27 (Wǔ Shū)" },
			{ id: "gb-28", name: "GB-28 (Wéi Dào)" },
			{ id: "gb-29", name: "GB-29 (Jū Liáo)" },
			{ id: "gb-30", name: "GB-30 (Huán Tiào)" },
			{ id: "gb-31", name: "GB-31 (Fēng Shì)" },
			{ id: "gb-32", name: "GB-32 (Zhōng Dú)" },
			{ id: "gb-33", name: "GB-33 (Xī Yáng Guān)" },
			{ id: "gb-34", name: "GB-34 (Yáng Líng Quán)" },
			{ id: "gb-35", name: "GB-35 (Yáng Jiāo)" },
			{ id: "gb-36", name: "GB-36 (Wài Qiū)" },
			{ id: "gb-37", name: "GB-37 (Guāng Míng)" },
			{ id: "gb-38", name: "GB-38 (Yáng Fǔ)" },
			{ id: "gb-39", name: "GB-39 (Xuán Zhōng)" },
			{ id: "gb-40", name: "GB-40 (Qiū Xū)" },
			{ id: "gb-41", name: "GB-41 (Zú Lín Qì)" },
			{ id: "gb-42", name: "GB-42 (Dì Wǔ Huì)" },
			{ id: "gb-43", name: "GB-43 (Xiá Xī)" },
			{ id: "gb-44", name: "GB-44 (Zú Qiào Yīn)" }
		],
		LIV_POINTS: [
			{ id: "liv-1", name: "LIV-1 (Dà Dūn)" },
			{ id: "liv-2", name: "LIV-2 (Xíng Jiān)" },
			{ id: "liv-3", name: "LIV-3 (Taì Chōng)" },
			{ id: "liv-4", name: "LIV-4 (Zhōng Fēng)" },
			{ id: "liv-5", name: "LIV-5 (Lǐ Gōu)" },
			{ id: "liv-6", name: "LIV-6 (Zhōng Dū)" },
			{ id: "liv-7", name: "LIV-7 (Xī Guān)" },
			{ id: "liv-8", name: "LIV-8 (Qū Quán)" },
			{ id: "liv-9", name: "LIV-9 (Yīn Bāo)" },
			{ id: "liv-10", name: "LIV-10 (Zú Wǔ Li)" },
			{ id: "liv-11", name: "LIV-11 (Yīn Lián)" },
			{ id: "liv-12", name: "LIV-12 (Jí Mài)" },
			{ id: "liv-13", name: "LIV-13 (Zhāng Mén)" },
			{ id: "liv-14", name: "LIV-14 (Qí Mén)" }
		],
		DU_POINTS: [
			{ id: "du-1", name: "DU-1 (Cháng Qiáng)" },
			{ id: "du-2", name: "DU-2 (Yāo Shū)" },
			{ id: "du-3", name: "DU-3 (Yāo Yáng Guān)" },
			{ id: "du-4", name: "DU-4 (Mìng Mén)" },
			{ id: "du-5", name: "DU-5 (Xuán Shū)" },
			{ id: "du-6", name: "DU-6 (Jì Zhōng)" },
			{ id: "du-7", name: "DU-7 (Zhōng Shū)" },
			{ id: "du-8", name: "DU-8 (Jīn Suō)" },
			{ id: "du-9", name: "DU-9 (Zhì Yáng)" },
			{ id: "du-10", name: "DU-10 (Líng Tái)" },
			{ id: "du-11", name: "DU-11 (Shén Dào)" },
			{ id: "du-12", name: "DU-12 (Shēn Zhù)" },
			{ id: "du-13", name: "DU-13 (Táo Dào)" },
			{ id: "du-14", name: "DU-14 (Dà Zhuī)" },
			{ id: "du-15", name: "DU-15 (Yǎ Mén)" },
			{ id: "du-16", name: "DU-16 (Fēng Fǔ)" },
			{ id: "du-17", name: "DU-17 (Nǎo Hù)" },
			{ id: "du-18", name: "DU-18 (Qiáng Jiān)" },
			{ id: "du-19", name: "DU-19 (Hòu Dǐng)" },
			{ id: "du-20", name: "DU-20 (Bǎi Huì)" },
			{ id: "du-21", name: "DU-21 (Qián Dǐng)" },
			{ id: "du-22", name: "DU-22 (Xìn Huì)" },
			{ id: "du-23", name: "DU-23 (Shàng Xīng)" },
			{ id: "du-24", name: "DU-24 (Shén Tíng)" },
			{ id: "du-25", name: "DU-25 (Sù Liáo)" },
			{ id: "du-26", name: "DU-26 (Rén Zhōng)" },
			{ id: "du-27", name: "DU-27 (Duì Duān)" },
			{ id: "du-28", name: "DU-28 (Yín Jiāo)" }
		],
		REN_POINTS: [
			{ id: "ren-1", name: "REN-1 (Huì Yīn)" },
			{ id: "ren-2", name: "REN-2 (Qū Gǔ)" },
			{ id: "ren-3", name: "REN-3 (Zhōng Jí)" },
			{ id: "ren-4", name: "REN-4 (Guān Yuán)" },
			{ id: "ren-5", name: "REN-5 (Shí Mén)" },
			{ id: "ren-6", name: "REN-6 (Qì Hǎi)" },
			{ id: "ren-7", name: "REN-7 (Yīn Jiāo)" },
			{ id: "ren-8", name: "REN-8 (Shén Què)" },
			{ id: "ren-9", name: "REN-9 (Shuǐ Fēn)" },
			{ id: "ren-10", name: "REN-10 (Xià Wǎn [Or Xià Guǎn])" },
			{ id: "ren-11", name: "REN-11 (Jiàn Lǐ)" },
			{ id: "ren-12", name: "REN-12 (Zhōng Wǎn [Or Zhōng Guǎn])" },
			{ id: "ren-13", name: "REN-13 (Shàng Wǎn [Or Shàng Guǎn])" },
			{ id: "ren-14", name: "REN-14 (Jù Què)" },
			{ id: "ren-15", name: "REN-15 (Jiū Wěi)" },
			{ id: "ren-16", name: "REN-16 (Zhōng Tíng)" },
			{ id: "ren-17", name: "REN-17 (Shān Zhōng)" },
			{ id: "ren-18", name: "REN-18 (Yù Táng)" },
			{ id: "ren-19", name: "REN-19 (Zǐ Gōng)" },
			{ id: "ren-20", name: "REN-20 (Huá Gài)" },
			{ id: "ren-21", name: "REN-21 (Xuán Jī)" },
			{ id: "ren-22", name: "REN-22 (Tiān Tū)" },
			{ id: "ren-23", name: "REN-23 (Lián Quán)" },
			{ id: "ren-24", name: "REN-24 (Chéng Jiāng)" }
		],
		EX_POINTS: [
			{ id: "ex-hn-54", name: "An Mian" },//
			{ id: "ex-hn-30", name: "Bai Lao" },//
			{ id: "ex-hn-14", name: "Bi Tong" },//
			{ id: "ex-hn-10", name: "Er Jian" },//
			{ id: "ex-hn-18", name: "Jia Cheng Jiang" },//
			{ id: "ex-hn-21", name: "Qian Zheng" },//
			{ id: "ex-hn-8", name: "Qiu Hou" },//
			{ id: "ex-hn-9", name: "Tai Yang" },//
			{ id: "ex-hn-32", name: "Yi Ming" },//
			{ id: "ex-hn-6", name: "Yu Yao" },//
			{ id: "ex-bw-1", name: "Ding Chuan" },//
			{ id: "ex-bw-35", name: "Hua Tuo Jia Ji" },//
			{ id: "ex-bw-3", name: "Pi Gen" },//
			{ id: "ex-bw-12", name: "Wei Guan Xia Xu" },//
			{ id: "ex-ue-22", name: "Ba Xie" },//
			{ id: "ex-ue-b", name: "Bi Zhong" },//
			{ id: "ex-ue-29", name: "Er Bai" },//
			{ id: "ex-ue-d", name: "Jian Qian" },//
			{ id: "ex-ue-24", name: "Luo Zhen" },//
			{ id: "ex-ue-1", name: "Shi Xuan" },//
			{ id: "ex-ue-9", name: "Si Feng" },//
			{ id: "ex-ue-19", name: "Yao Tong Xue" },//
			{ id: "ex-ue-e", name: "Zhong Kui" },//
			{ id: "ex-ue-f", name: "Zhong Quan" },//
			{ id: "ex-ue-46", name: "Zhou Jian" },//
			{ id: "ex-hn-31", name: "Shang Lian Quan" },//center
			{ id: "ex-bw-4", name: "Yao Qi" },//center
			{ id: "ex-bw-2", name: "Huan Zhong" },
			{ id: "ex-bw-24", name: "Yao Yan" },
			{ id: "ex-ca-4", name: "Ti Tuo" },
			{ id: "ex-ca-18", name: "Zi Gong Xue" },
			{ id: "ex-ue-c", name: "Jian Nei Ling" },
			{ id: "ex-le-8", name: "Ba Feng" },
			{ id: "ex-le-34", name: "Bai Chong Wo" },
			{ id: "ex-le-23", name: "Dan Nang Xue" },
			{ id: "ex-le-27", name: "He Ding" },
			{ id: "ex-le-13", name: "Lan Wei Xue" },
			{ id: "ex-le-30", name: "Nao Qing" },
			{ id: "ex-le-25", name: "Shi Mian" }
		],
		EX_CENTRAL_POINTS: [
			{ id: "ex-bw-25", name: "Shi Qi Zhui Xia" },
			{ id: "ex-ca-23", name: "San Jiao Jiu" },
			{ id: "ex-hn-1", name: "Si Shen Chong" },
			{ id: "ex-hn-3", name: "Yin Tang" },
			{ id: "ex-hn-20", name: "Jin Jin Yu Ye" }
		],
		ONE_POINTS: [
			{ id: "11-1", name: ""},
			{ id: "11-2", name: ""},
			{ id: "11-3", name: ""},
			{ id: "11-4", name: ""},
			{ id: "11-5", name: ""},
			{ id: "11-6", name: ""},
			{ id: "11-7", name: ""},
			{ id: "11-8", name: ""},
			{ id: "11-9", name: ""},
			{ id: "11-10", name: ""},
			{ id: "11-11", name: ""},
			{ id: "11-12", name: ""},
			{ id: "11-13", name: ""},
			{ id: "11-14", name: ""},
			{ id: "11-15", name: ""},
			{ id: "11-16", name: ""},
			{ id: "11-17", name: ""},
			{ id: "11-18", name: ""},
			{ id: "11-19", name: ""},
			{ id: "11-20", name: ""},
			{ id: "11-21", name: ""},
			{ id: "11-22", name: ""},
			{ id: "11-23", name: ""},
			{ id: "11-24", name: ""},
			{ id: "11-25", name: ""},
			{ id: "11-26", name: ""},
			{ id: "11-27", name: ""},
			{ id: "11-28", name: ""},
			{ id: "11-29", name: ""},
			{ id: "11-30", name: ""},
			{ id: "11-31", name: ""}
		],
		TWO_POINTS: [
			{ id: "22-1", name: ""},
			{ id: "22-2", name: ""},
			{ id: "22-3", name: ""},
			{ id: "22-4", name: ""},
			{ id: "22-5", name: ""},
			{ id: "22-6", name: ""},
			{ id: "22-7", name: ""},
			{ id: "22-8", name: ""},
			{ id: "22-9", name: ""},
			{ id: "22-10", name: ""},
			{ id: "22-11", name: ""},
			{ id: "22-12", name: ""},
			{ id: "22-13", name: ""},
			{ id: "22-14", name: ""},
			{ id: "22-15", name: ""},
			{ id: "22-16", name: ""},
			{ id: "22-17", name: ""},
			{ id: "22-18", name: ""},
			{ id: "22-19", name: ""},
			{ id: "22-20", name: ""},
			{ id: "22-21", name: ""},
			{ id: "22-22", name: ""},
			{ id: "22-23", name: ""},
			{ id: "22-24", name: ""},
			{ id: "22-25", name: ""},
			{ id: "22-26", name: ""},
			{ id: "22-27", name: ""},
		],
		THREE_POINTS: [
			{ id: "33-1", name: ""},
			{ id: "33-2", name: ""},
			{ id: "33-3", name: ""},
			{ id: "33-4", name: ""},
			{ id: "33-5", name: ""},
			{ id: "33-6", name: ""},
			{ id: "33-7", name: ""},
			{ id: "33-8", name: ""},
			{ id: "33-9", name: ""},
			{ id: "33-10", name: ""},
			{ id: "33-11", name: ""},
			{ id: "33-12", name: ""},
			{ id: "33-13", name: ""},
			{ id: "33-14", name: ""},
			{ id: "33-15", name: ""},
			{ id: "33-16", name: ""},
			{ id: "33-17", name: ""},
			{ id: "33-18", name: ""},
			{ id: "33-19", name: ""},
			{ id: "33-20", name: ""}
		],
		FOUR_POINTS: [
			{ id: "44-1", name: ""},
			{ id: "44-2", name: ""},
			{ id: "44-3", name: ""},
			{ id: "44-4", name: ""},
			{ id: "44-5", name: ""},
			{ id: "44-6", name: ""},
			{ id: "44-7", name: ""},
			{ id: "44-8", name: ""},
			{ id: "44-9", name: ""},
			{ id: "44-10", name: ""},
			{ id: "44-11", name: ""},
			{ id: "44-12", name: ""},
			{ id: "44-13", name: ""},
			{ id: "44-14", name: ""},
			{ id: "44-15", name: ""},
			{ id: "44-16", name: ""},
			{ id: "44-17", name: ""},
			{ id: "44-18", name: ""},
			{ id: "44-19", name: ""},
			{ id: "44-20", name: ""},
			{ id: "44-21", name: ""},
			{ id: "44-22", name: ""},
			{ id: "44-23", name: ""},
			{ id: "44-24", name: ""},
			{ id: "44-25", name: ""},
			{ id: "44-26", name: ""},
			{ id: "44-27", name: ""},
			{ id: "44-28", name: ""},
			{ id: "44-29", name: ""},
			{ id: "44-30", name: ""},
			{ id: "44-31", name: ""}
		],
		FIVE_POINTS: [
			{ id: "55-1", name: ""},
			{ id: "55-2", name: ""},
			{ id: "55-3", name: ""},
			{ id: "55-4", name: ""},
			{ id: "55-5", name: ""},
			{ id: "55-6", name: ""},
			{ id: "55-7", name: ""}
		],
		SIX_POINTS: [
			{ id: "66-1", name: ""},
			{ id: "66-2", name: ""},
			{ id: "66-3", name: ""},
			{ id: "66-4", name: ""},
			{ id: "66-5", name: ""},
			{ id: "66-6", name: ""},
			{ id: "66-7", name: ""},
			{ id: "66-8", name: ""},
			{ id: "66-9", name: ""},
			{ id: "66-10", name: ""},
			{ id: "66-11", name: ""},
			{ id: "66-12", name: ""},
			{ id: "66-13", name: ""},
			{ id: "66-14", name: ""},
			{ id: "66-15", name: ""},
			{ id: "66-16", name: ""}
		],
		SEVEN_POINTS: [
			{ id: "77-1", name: ""},
			{ id: "77-2", name: ""},
			{ id: "77-3", name: ""},
			{ id: "77-4", name: ""},
			{ id: "77-5", name: ""},
			{ id: "77-6", name: ""},
			{ id: "77-7", name: ""},
			{ id: "77-8", name: ""},
			{ id: "77-9", name: ""},
			{ id: "77-10", name: ""},
			{ id: "77-11", name: ""},
			{ id: "77-12", name: ""},
			{ id: "77-13", name: ""},
			{ id: "77-14", name: ""},
			{ id: "77-15", name: ""},
			{ id: "77-16", name: ""},
			{ id: "77-17", name: ""},
			{ id: "77-18", name: ""},
			{ id: "77-19", name: ""},
			{ id: "77-20", name: ""},
			{ id: "77-21", name: ""},
			{ id: "77-22", name: ""},
			{ id: "77-23", name: ""},
			{ id: "77-24", name: ""},
			{ id: "77-25", name: ""},
			{ id: "77-26", name: ""},
			{ id: "77-27", name: ""},
			{ id: "77-28", name: ""},
			{ id: "77-29", name: ""},
			{ id: "77-30", name: ""}
		],
		EIGHT_POINTS: [
			{ id: "88-1", name: ""},
			{ id: "88-2", name: ""},
			{ id: "88-3", name: ""},
			{ id: "88-4", name: ""},
			{ id: "88-5", name: ""},
			{ id: "88-6", name: ""},
			{ id: "88-7", name: ""},
			{ id: "88-8", name: ""},
			{ id: "88-9", name: ""},
			{ id: "88-10", name: ""},
			{ id: "88-11", name: ""},
			{ id: "88-12", name: ""},
			{ id: "88-13", name: ""},
			{ id: "88-14", name: ""},
			{ id: "88-15", name: ""},
			{ id: "88-16", name: ""},
			{ id: "88-17", name: ""},
			{ id: "88-18", name: ""},
			{ id: "88-19", name: ""},
			{ id: "88-20", name: ""},
			{ id: "88-21", name: ""},
			{ id: "88-22", name: ""},
			{ id: "88-23", name: ""},
			{ id: "88-24", name: ""},
			{ id: "88-25", name: ""},
			{ id: "88-26", name: ""},
			{ id: "88-27", name: ""},
			{ id: "88-28", name: ""},
			{ id: "88-29", name: ""},
			{ id: "88-30", name: ""},
			{ id: "88-31", name: ""},
			{ id: "88-32", name: ""},
			{ id: "88-33", name: ""},
			{ id: "88-34", name: ""},
			{ id: "88-35", name: ""},
			{ id: "88-36", name: ""},
			{ id: "88-37", name: ""},
			{ id: "88-38", name: ""},
			{ id: "88-39", name: ""},
			{ id: "88-40", name: ""},
			{ id: "88-41", name: ""},
			{ id: "88-42", name: ""},
			{ id: "88-43", name: ""},
			{ id: "88-44", name: ""},
			{ id: "88-45", name: ""},
			{ id: "88-46", name: ""},
			{ id: "88-47", name: ""},
			{ id: "88-48", name: ""},
			{ id: "88-49", name: ""},
			{ id: "88-50", name: ""},
			{ id: "88-51", name: ""}
		],
		NINE_POINTS: [
			{ id: "99-1", name: ""},
			{ id: "99-2", name: ""},
			{ id: "99-3", name: ""},
			{ id: "99-4", name: ""},
			{ id: "99-5", name: ""},
			{ id: "99-6", name: ""},
			{ id: "99-7", name: ""},
			{ id: "99-8", name: ""},
			{ id: "99-9", name: ""},
			{ id: "99-10", name: ""},
			{ id: "99-11", name: ""},
			{ id: "99-12", name: ""},
			{ id: "99-13", name: ""},
			{ id: "99-14", name: ""},
			{ id: "99-15", name: ""},
			{ id: "99-16", name: ""},
			{ id: "99-17", name: ""},
			{ id: "99-18", name: ""},
			{ id: "99-19", name: ""},
			{ id: "99-20", name: ""},
			{ id: "99-21", name: ""},
		],
		TEN_POINTS: [
			{ id: "1010-2", name: ""},
			{ id: "1010-3", name: ""},
			{ id: "1010-4", name: ""},
			{ id: "1010-9", name: ""},
			{ id: "1010-10", name: ""},
			{ id: "1010-11", name: ""},
			{ id: "1010-13", name: ""},
			{ id: "1010-14", name: ""},
			{ id: "1010-15", name: ""},
			{ id: "1010-16", name: ""},
			{ id: "1010-17", name: ""},
			{ id: "1010-18", name: ""},
			{ id: "1010-19", name: ""},
			{ id: "1010-20", name: ""},
			{ id: "1010-21", name: ""},
			{ id: "1010-22", name: ""},
			{ id: "1010-23", name: ""},
			{ id: "1010-24", name: ""}
		],
		TEN_CENTRAL_POINTS: [
			{ id: "1010-1", name: ""},
			{ id: "1010-5", name: ""},
			{ id: "1010-6", name: ""},
			{ id: "1010-7", name: ""},
			{ id: "1010-8", name: ""},
			{ id: "1010-12", name: ""},
			{ id: "1010-25", name: ""}
		],
		DT_POINTS: [
			{ id: "dt-1", name: ""},
			{ id: "dt-2", name: ""}
		],
		DT_CENTRAL_POINTS: [
			{ id: "dt-3", name: ""},
			{ id: "dt-4", name: ""},
			{ id: "dt-5", name: ""},
			{ id: "dt-6", name: ""},
			{ id: "dt-7", name: ""},
			{ id: "dt-8", name: ""},
			{ id: "dt-9", name: ""},
			{ id: "dt-10", name: ""},
			{ id: "dt-11", name: ""},
			{ id: "dt-12", name: ""},
			{ id: "dt-13", name: ""},
			{ id: "dt-14", name: ""},
			{ id: "dt-15", name: ""},
			{ id: "dt-16", name: ""},
			{ id: "dt-17", name: ""}
		],
		VT_POINTS: [
			{ id: "vt-1", name: ""},
			{ id: "vt-2", name: ""},
			{ id: "vt-3", name: ""},
			{ id: "vt-4", name: ""},
			{ id: "vt-5", name: ""}
		],
		VT_CENTRAL_POINTS: [
			{ id: "vt-1", name: ""},
			{ id: "vt-2", name: ""},
			{ id: "vt-3", name: ""},
			{ id: "vt-4", name: ""},
			{ id: "vt-5", name: ""}
		]
  }),
  computed: {
		technics() {
			let technics = [
        {id: 1, name: this.$gettext("Acupuncture"), icon: '$vuetify.icons.acuIcon', acu: true, auricular: true},
        {id: 2, name: this.$gettext("Moxa"), icon: '$vuetify.icons.acuTechnic4', acu: true, auricular: true},
        {id: 3, name: this.$gettext("Bleeding"), icon: '$vuetify.icons.acuTechnic1', acu: true, auricular: true},
        {id: 4, name: this.$gettext("Cupping"), icon: '$vuetify.icons.acuTechnic3', acu: true, auricular: false},
        {id: 5, name: this.$gettext("Electro"), icon: '$vuetify.icons.acuTechnic2', acu: true, auricular: true},
        {id: 6, name: this.$gettext("Magnetic Sphere"), icon: 'mdi-circle-slice-8', acu: false, auricular: true},
        {id: 7, name: this.$gettext("Seeds"), icon: 'mdi-circle-medium', acu: false, auricular: true},
        {id: 8, name: this.$gettext("ASP"), icon: 'mdi-arrow-down-bold', acu: false, auricular: true},
        {id: 9, name: this.$gettext("TDP"), icon: 'mdi-white-balance-sunny', acu: true, auricular: false}
      ]
			//return this.$store.getters.acuTechnics(this.auricular);
			if(this.auricular) return technics.filter(t => t.auricular);
      else return technics.filter(t => t.acu);
		},
		required() {
			return value => !!value || this.$gettext("Required.");
		},
		channelRows() {
			if(this.acuType == 'tung') return [this.channelsRowOneTung, this.channelsRowTwoTung, this.channelsRowThreeTung, this.channelsRowFourTung, this.channelsRowFiveTung, this.channelsRowSix]
			return [this.channelsRowOne, this.channelsRowTwo, this.channelsRowThree, this.channelsRowFour, this.channelsRowFive, this.channelsRowSix]
		},
    classicGroups() {
			return this.$store.getters.acuClassicGroups(false);
		},
		customGroups() {
			return this.$store.getters.acuCustomGroups(false);
		},
		acuPoints() {
			return this.$store.getters.acuPoints(this.auricular);
		},
		ashiPoints() {
			return this.$store.getters.ashiPoints;
		},
		ashiPoints1() {
			return this.$store.getters.ashiPoints;
		},
		ashiPoints2() {
			return this.$store.getters.ashiPoints;
		},
		ashiPoints3() {
			return this.$store.getters.ashiPoints;
		},
		ashiPoints4() {
			return this.$store.getters.ashiPoints;
		},
		ashiPoints5() {
			return this.$store.getters.ashiPoints;
		},
		ashiPoints6() {
			return this.$store.getters.ashiPoints;
		},
		saving() {
			return this.$store.getters.acuLoading;
		},
		points() {
			if (this.channel === "lu") return this.LU_POINTS;
			if (this.channel === "li") return this.LI_POINTS;
			if (this.channel === "st") return this.ST_POINTS;
			if (this.channel === "sp") return this.SP_POINTS;
			if (this.channel === "he") return this.HE_POINTS;
			if (this.channel === "si") return this.SI_POINTS;
			if (this.channel === "bl") return this.BL_POINTS;
			if (this.channel === "kd") return this.KD_POINTS;
			if (this.channel === "pc") return this.PC_POINTS;
			if (this.channel === "sj") return this.SJ_POINTS;
			if (this.channel === "gb") return this.GB_POINTS;
			if (this.channel === "liv") return this.LIV_POINTS;
			if (this.channel === "du") return this.DU_POINTS;
			if (this.channel === "ren") return this.REN_POINTS;
			if (this.channel === "ex") return this.EX_POINTS;
			if (this.channel === "ex-central") return this.EX_CENTRAL_POINTS;
			if (this.channel === "11") return this.ONE_POINTS;
			if (this.channel === "22") return this.TWO_POINTS;
			if (this.channel === "33") return this.THREE_POINTS;
			if (this.channel === "44") return this.FOUR_POINTS;
			if (this.channel === "55") return this.FIVE_POINTS;
			if (this.channel === "66") return this.SIX_POINTS;
			if (this.channel === "77") return this.SEVEN_POINTS;
			if (this.channel === "88") return this.EIGHT_POINTS;
			if (this.channel === "99") return this.NINE_POINTS;
			if (this.channel === "1010") return this.TEN_POINTS;
			if (this.channel === "1010-central") return this.TEN_CENTRAL_POINTS;
			if (this.channel === "dt") return this.DT_POINTS;
			if (this.channel === "dt-central") return this.DT_CENTRAL_POINTS;
			if (this.channel === "vt") return this.VT_POINTS;
			if (this.channel === "vt-central") return this.VT_CENTRAL_POINTS;
			else return [];
		},
		moxiSelected() {
			for(let i=0; i<this.pointTechnics.length; i++) {
				if(this.pointTechnics[i] == 2) return true
			}
			return false;
		},
		quadrantName() {
			if(this.newPoint.quadrant == 1) return this.$gettext("Superior Right");
			if(this.newPoint.quadrant == 2) return this.$gettext("Superior Left");
			if(this.newPoint.quadrant == 3) return this.$gettext("Inferior Right");
			if(this.newPoint.quadrant == 4) return this.$gettext("Inferior Left");
			if(this.newPoint.quadrant == 5) return this.$gettext("Superior Center");
			if(this.newPoint.quadrant == 6) return this.$gettext("Inferior Center");
			return "";
		},
		tanSelectedChannels() {
			let channels = [];
			for(let i = 0; i < this.channelRows.length; i++) {
				for(let h = 0; h < this.channelRows[i].length; h++) {
					if(this.channelRows[i][h].tanSelected) channels.push(this.channelRows[i][h]);
				}
			}
			return channels;
		},
		tanResultChannels() {
			let channels = [];
			for(let i = 0; i < this.channelRows.length; i++) {
				for(let h = 0; h < this.channelRows[i].length; h++) {
					if(this.channelRows[i][h].tanResult > 0) channels.push(this.channelRows[i][h]);
				}
			}
			return channels;
		},
		tanResultSelectedChannels() {
			let channels = [];
			for(let i = 0; i < this.channelRows.length; i++) {
				for(let h = 0; h < this.channelRows[i].length; h++) {
					if(this.balanceType == 'local') {
						if(this.channelRows[i][h].tanResult > 0 && this.channelRows[i][h].tanSeletedResult) channels.push(this.channelRows[i][h]);
					} else {
						if(this.channelRows[i][h].tanSeletedResult) channels.push(this.channelRows[i][h]);
					}
				}
			}
			return channels;
		},
		coverageResults() {
			let totalSelected;
			let totalCovered;
			if(this.balanceType == 'local') {
				totalSelected = this.tanSelectedChannels.length;
				totalCovered = 0;
				for(let i = 0; i < totalSelected; i++) {
					if(this.channelCovered(this.tanSelectedChannels[i])) totalCovered += 1;
				}
			} else {
				totalSelected = 4;
				totalCovered = this.tanResultSelectedChannels.length;
			}
			var percentage = (totalCovered * 100) / totalSelected;
			percentage = Math.round(percentage);
			return percentage;
		},
		coveragePoints() {
			let	totalSelected;
			if(this.balanceType == 'local') totalSelected = this.tanSelectedChannels.length;
			else totalSelected = this.tanResultSelectedChannels.length;
			let	totalCovered = 0;
			for(let i = 0; i < totalSelected; i++) {
				if(this.balanceType == 'local') {
					if(this.channelComplete(this.tanSelectedChannels[i])) totalCovered += 1;
				} else {
					if(this.channelComplete(this.tanResultSelectedChannels[i])) totalCovered += 1;
				}
			}
			var percentage = (totalCovered * 100) / totalSelected;
			percentage = Math.round(percentage);
			return percentage;
		},
		tanComplete() {
			if(this.tanSelectedChannels.length == 0) return false;
			for(let i = 0; i < this.tanSelectedChannels.length; i++) {
				if(!this.channelComplete(this.tanSelectedChannels[i])) return false;
			}
			return true;
		},
		tanSolutionsOrdered() {
			if(this.balanceType == 'general') return this.tanSolutions;
			return this.tanSolutions.filter((solution) => this.showSolution(solution)).sort((a, b) => {
				let numCoversA = 0;
				for(let i = 0; i < a.length; i++) {
					numCoversA += a[i].tanCovers.length;
				}
				let numCoversB = 0;
				for(let h = 0; h < b.length; h++) {
					numCoversB += b[h].tanCovers.length;
				}
				return numCoversA < numCoversB;
			});
		},
		...mapGetters({
      tourStep: 'tourStepEvent'
    })
	},
  methods: {
		addPoint() {
			var ids = [];
			if (this.position == "bilateral") {
				ids.push(this.point + "R");
				ids.push(this.point + "L");
			} else if (this.position == "left") {
				ids.push(this.point + "L");
			} else if (this.position == "right") {
				ids.push(this.point + "R");
			} else if (this.position == "center") {
				ids.push(this.point + "C");
			}
			let appointment;
			if(this.createMode) appointment = -1;
			else appointment = this.$route.params.aid;
			let data = {
				appointment: appointment,
				op: "add_points",
				ids: ids,
				technics: this.pointTechnics
			}
			this.$store.dispatch("ADD_POINTS", data);
		},
		removePoint(point) {
			let appointment;
			if(this.createMode) appointment = -1;
			else appointment = this.$route.params.aid;
			let data = {
				appointment: appointment,
				op: "remove_point",
				id: point.id
			}
			this.$store.dispatch("REMOVE_POINT", data);
		},
		createPoint() {
			if(this.$refs.newPointForm.validate()) {
				if(this.newPoint.quadrant == 1 || this.newPoint.quadrant == 3) this.newPoint.side = 'right'
				if(this.newPoint.quadrant == 2 || this.newPoint.quadrant == 4) this.newPoint.side = 'left'
				if(this.newPoint.quadrant == 5 || this.newPoint.quadrant == 6) this.newPoint.side = 'center'
				let data = [];
				let point = {
					name: this.newPoint.name,
					cx: null,
					cy: null,
					side: this.newPoint.side,
					quadrant: this.newPoint.quadrant,
					ashi: true,
					auricular: this.auricular,
					custom: true
				}
				data.push(point);
				//if(this.admin) data.custom = false;
				this.$store.dispatch("CREATE_POINT", data).then((points) => {
					this.addAshiPoint({id: points[0].id});
					this.showNewPoint = false;
				}).catch(() => {
					this.pointExists = true;
				});
			}
		},
		addAshiPoint(point) {
			let appointment;
			if(this.createMode) appointment = -1;
			else appointment = this.$route.params.aid;
			let data = {
				appointment: appointment,
				op: "add_points",
				ids: [point.id],
				technics: this.pointTechnics
			}
			this.$store.dispatch("ADD_POINTS", data).then(() => {});
		},
		getNumber(point) {
			if(this.channel == 'ex' || this.channel == 'ex-central') return point.name;
			else return point.id.split("-")[1];
		},
		selectChannel(channel) {
			if(this.tan && (this.tanStep == 1 || this.tanStep == 2)) {
				if(this.tanStep == 1) channel.tanSelected = !channel.tanSelected;
				if(this.tanStep == 2 && channel.tanResult > 0) channel.tanSeletedResult = !channel.tanSeletedResult;
				return 0;
			}
			if(this.channel == channel.id && this.position == channel.position) {this.channel = ''}
			else if(this.channel == channel.id && this.position == 'bilateral') {
				if(channel.position == 'right') this.position = 'left';
				else this.position = 'right';
			}
			else if(this.channel == channel.id && this.position != channel.position) this.position = 'bilateral';
			else {
				this.channel = channel.id;
				this.position = channel.position;
			}
		},
		clickCustomGroup(id) {
			for(let i = 0; i < this.selectedCustomGroups.length; i++) {
				if(this.selectedCustomGroups[i] == id) {
					this.removeCustomGroup(id);
					return 0;
				}
			}
			this.aplyCustomGroup(id);
			return 0;
		},
		aplyCustomGroup(id) {
			let appointment;
			if(this.createMode) appointment = -1;
			else appointment = this.$route.params.aid;
			let data = {
				appointment: appointment,
				op: "aply_custom_group",
				group_id: id
			};
			this.$store.dispatch("APLY_CUSTOM_GROUP", data).then(() => {});
		},
		removeCustomGroup(id) {
			let appointment;
			if(this.createMode) appointment = -1;
			else appointment = this.$route.params.aid;
			let data = {
				appointment: appointment,
				op: "remove_custom_group",
				group_id: id
			}
			this.$store.dispatch("REMOVE_CUSTOM_GROUP", data).then(() => {});
		},
		clickCreateGroup() {
			this.newGroup = {
				name: "",
				color: "",
				auricular: this.auricular,
				points: JSON.parse(JSON.stringify(this.acuPoints)),
				ashi_points: this.appointmentAshiPoints
			}
			this.showNewGroup = true;
		},
		createGroup() {
			if(this.$refs.newGroupForm.validate()) {
				if(this.admin) this.newGroup.custom = false;
				else this.newGroup.custom = true;
				this.$store.dispatch("CREATE_GROUP", this.newGroup).then(() => {
					this.showNewGroup = false;
					this.showSaveTreatment = false;
				});
			}
		},
		setGroupToEdit(id) {
			this.showEditGroup = true;
			this.$store.dispatch("GET_GROUP_INFO", {id: id, form: false}).then((group) => {
				this.groupToEdit = group;
			});
		},
		editGroup() {
			if(this.$refs.groupForm.validate()) {
				this.groupToEdit.form = false;
				this.$store.dispatch("EDIT_GROUP", this.groupToEdit).then(() => {
					this.groupToEdit = null;
					this.showEditGroup = false;
				});
			}
		},
		addPointToGroup(point, group) {
			let exist = group.points.find(p => p.id === point.id);
			if(exist) console.log("already in");
			else {
				point.technics = this.pointTechnics;
				group.points.push(point);
			}
		},
		removePointFromGroup(point, group) {
			group.points.splice(group.points.indexOf(point), 1);
		},
		deleteGroup() {
			this.$store.dispatch("DELETE_GROUP", this.groupToEdit).then(() => {
				this.groupToEdit = null;
				this.showEditGroup = false;
			});
		},
		saveAshi() {
			let appointment;
			if(this.createMode) appointment = -1;
			else appointment = this.$route.params.aid;
			let data = {
				appointment: appointment,
				op: "save_ashi",
				ashi_points: this.appointmentAshiPoints
			}
			this.$store.dispatch("SAVE_ASHI", data);
			//this.$emit("save-ashi", response.data);
		},
		existPoint(point) {
			if(this.position == 'bilateral') {
				let idLeft = {id: point.id + "L", exist: false, point: null};
				let idRight = {id: point.id + "R", exist: false, point: null};
				for(let i in this.acuPoints) {
					if(this.acuPoints[i].id == idLeft.id) {idLeft.exist = true; idLeft.point=this.acuPoints[i]}
					if(this.acuPoints[i].id == idRight.id) {idRight.exist = true; idRight.point=this.acuPoints[i]}
				}
				if(idLeft.exist && idRight.exist) return {result: true, points: [idLeft.point, idRight.point]};
			} else {
				let p = {id: point.id + this.position.charAt(0).toUpperCase(), point: null};
				for(let i in this.acuPoints) {
					if(this.acuPoints[i].id == p.id) {p.point=this.acuPoints[i]; return {result: true, points: [p.point]}}
				}
			}
			return {result: false};
		},
		existChannel(channel) {
			if(!this.tan && this.channel == channel.id && (this.position == channel.position || this.position == 'bilateral')) return true;
			for(let i in this.acuPoints) {
				if(channel.id == 'ex-central' && (this.acuPoints[i].id == 'ex-bw-25C' || this.acuPoints[i].id == 'ex-ca-23C' || this.acuPoints[i].id == 'ex-hn-1C' || this.acuPoints[i].id == 'ex-hn-3C' || this.acuPoints[i].id == 'ex-hn-20C')) return true;
				if(this.acuPoints[i].id.split("-")[0] == channel.id && this.acuPoints[i].id.charAt(this.acuPoints[i].id.length - 1) == channel.position.charAt(0).toUpperCase()) return true;
			}
			return false;
		},
		existChannelTan(channel) {
			if(this.tanStep == 2) {
				if(channel.tanSeletedResult || channel.highlight) return true
			}
			if(this.tanStep == 3) {
				if(this.existChannel(channel) || channel.highlight) return true
			}
			return false
		},
		getPointColor(point) {
			if(this.position == 'bilateral') {
				let idLeft = {id: point.id + "L", exist: false};
				let idRight = {id: point.id + "R", exist: false};
				for(let i in this.acuPoints) {
					if(this.acuPoints[i].id == idLeft.id) idLeft.exist = true;
					if(this.acuPoints[i].id == idRight.id) idRight.exist = true;
				}
				if(idLeft.exist && idRight.exist) return "green";
			} else {
				let id = point.id + this.position.charAt(0).toUpperCase();
				for(let i in this.acuPoints) {
					if(this.acuPoints[i].id == id) return "green";
				}
			}
			return "";
		},
		clickPoint(point) {
			let data = this.existPoint(point);
			if(!data.result) {
				this.point = point.id;
				this.addPoint()
			}
			else {
				for(let i in data.points) {
					this.removePoint(data.points[i]);
				}
			}
		},
		getChannelName(channel) {
			if(channel == 'lu') return this.$gettext('Lung')
			if(channel == 'pc') return this.$gettext('Pericardium')
			if(channel == 'he') return this.$gettext('Heart')
			if(channel == 'si') return this.$gettext('Small Intestine')
			if(channel == 'sj') return this.$gettext('Sanjiao')
			if(channel == 'li') return this.$gettext('Large Intestine')
			if(channel == 'sp') return this.$gettext('Spleen')
			if(channel == 'liv') return this.$gettext('Liver')
			if(channel == 'kd') return this.$gettext('Kidney')
			if(channel == 'bl') return this.$gettext('Bladder')
			if(channel == 'gb') return this.$gettext('Gall Bladder')
			if(channel == 'st') return this.$gettext('Stomach')
			if(channel == 'ren') return this.$gettext('Ren Mai')
			if(channel == 'du') return this.$gettext('Du Mai')
			if(channel == 'ex') return this.$gettext('Extra')
			if(channel == 'ex-central') return this.$gettext('Extra')
			if(channel == 'ashi') return "Ashi"
		},
		getChannelInitials(channel) {
			if(channel == 'LU') return this.$gettext('LU')
			if(channel == 'PC') return this.$gettext('PC')
			if(channel == 'HE') return this.$gettext('HE')
			if(channel == 'SI') return this.$gettext('SI')
			if(channel == 'SJ') return this.$gettext('SJ')
			if(channel == 'LI') return this.$gettext('LI')
			if(channel == 'SP') return this.$gettext('SP')
			if(channel == 'LIV') return this.$gettext('LIV')
			if(channel == 'KD') return this.$gettext('KD')
			if(channel == 'BL') return this.$gettext('BL')
			if(channel == 'GB') return this.$gettext('GB')
			if(channel == 'ST') return this.$gettext('ST')
			if(channel == 'REN') return this.$gettext('REN')
			if(channel == 'DU') return this.$gettext('DU')
			if(channel == 'EX') return this.$gettext('EX')
			if(channel == 'ASHI') return "ASHI"
			return channel;
		},
		getChannelColor(chan) {
			if(this.tan) {
				if(this.tanStep == 1 && chan.tanSelected) return 'red lighten-3'
				else if(this.tanStep == 2){
					if(chan.highlight) return 'green'
					if(chan.tanResult) {
						if(this.channelInFilteredSolutions(chan) || chan.tanSeletedResult) return 'blue lighten-2'
						else return 'grey darken-3'
					}
					if(this.channelCovered(chan)) return 'green'
				}
				else if(this.tanStep == 3) {
					if(this.channelCovered(chan)) return 'green'
					if(chan.highlight) return 'green'
					if(chan.tanResult) {
						if(chan.tanSeletedResult) return 'blue lighten-2'
						else return 'grey darken-3'
					}
				}
				return 'grey'
			} else {
				if(this.channel == chan.id && (this.position == chan.position || this.position == 'bilateral')) return 'green';
				else return chan.color
			}
		},
		getButtonClasses(channel) {
			if(this.tan && this.tanStep != 1 && channel.tanSelected) {
				if(this.channelComplete(channel)) return 'mx-1 pa-0 tanSelectedComplete';
				else return 'mx-1 pa-0 tanSelected';
			}
			else return 'mx-1 pa-0';
		},
		getChannelLaterality(position) {
			if(position == 'left') return this.$gettext("Left");
			else if(position == 'right') return this.$gettext("Right");
			else return this.$gettext("Center");
		},
		removeAllPoints() {
			let appointment;
			if(this.createMode) appointment = -1;
			else appointment = this.$route.params.aid;
			let data = {
				appointment: appointment,
				op: "remove_all_points",
				auricular: this.auricular
			}
			this.$store.dispatch("REMOVE_ALL_POINTS", data).then(() => {this.showRemoveAllPoints = false;});
		},
		//TAN
		channelCovered(channel) {
			for(let i = 0; i < channel.tanCovered.length; i++) {
				if(channel.tanCovered[i].tanSeletedResult) return true;
			}
			return false;
		},
		channelComplete(channel) {
			if(this.balanceType == 'local') {
				for(let i = 0; i < channel.tanCovered.length; i++) {
					if(this.existChannel(channel.tanCovered[i])) return true;
				}
				return false;
			} else {
				return this.existChannel(channel);
			}
		},
		resetTan() {
			console.log("RESET TAN");
			this.channel = '';
			this.tan = false;
			this.tanStep = 1;
			this.tanSolutions = [];
			this.tanSolutionsStructures = [];
			for(let i = 0; i < this.channelRows.length; i++) {
				for(let h = 0; h < this.channelRows[i].length; h++) {
					this.channelRows[i][h].tanSelected = false;
					this.channelRows[i][h].tanCovers = [];
					this.channelRows[i][h].tanCovered = [];
					this.channelRows[i][h].tanResult = 0;
					this.channelRows[i][h].tanSeletedResult = false;
					this.channelRows[i][h].highlight = false;
				}
			}
		},
		restartTan() {
			this.resetTan();
			this.tan = true;
		},
		resetResults() {
			for(let i = 0; i < this.channelRows.length; i++) {
				for(let h = 0; h < this.channelRows[i].length; h++) {
					this.channelRows[i][h].tanCovers = [];
					this.channelRows[i][h].tanCovered = [];
					this.channelRows[i][h].tanResult = 0;
					this.channelRows[i][h].tanSeletedResult = false;
					this.channelRows[i][h].highlight = false;
				}
			}
			this.tanSolutions = [];
		},
		calculateTanLocal() {
			for(let i = 0; i < this.tanSelectedChannels.length; i++) {
				this.setChannelResult(this.tanSelectedChannels[i]);
			}
		},
		//GLOBAL
		calculateTanGlobal() {
			let structs = [
				{
					1: {to: [{quadrant: 2, systems: [3]}, {quadrant: 3, systems: [1, 5]}]},
					2: {to: [{quadrant: 1, systems: [3]}, {quadrant: 4, systems: [1, 5]}]},
					3: {to: [{quadrant: 1, systems: [1, 5]}, {quadrant: 4, systems: [3]}]},
					4: {to: [{quadrant: 2, systems: [1, 5]}, {quadrant: 3, systems: [3]}]}
				},
				{
					1: {to: [{quadrant: 3, systems: [1, 5]}, {quadrant: 4, systems: [2, 4]}]},
					2: {to: [{quadrant: 3, systems: [2, 4]}, {quadrant: 4, systems: [1, 5]}]},
					3: {to: [{quadrant: 2, systems: [2, 4]}, {quadrant: 1, systems: [1, 5]}]},
					4: {to: [{quadrant: 1, systems: [2, 4]}, {quadrant: 2, systems: [1, 5]}]}
				},
				{
					1: {to: [{quadrant: 2, systems: [3]}, {quadrant: 4, systems: [2, 4]}]},
					2: {to: [{quadrant: 1, systems: [3]}, {quadrant: 3, systems: [2, 4]}]},
					3: {to: [{quadrant: 2, systems: [2, 4]}, {quadrant: 4, systems: [3]}]},
					4: {to: [{quadrant: 1, systems: [2, 4]}, {quadrant: 3, systems: [3]}]}
				}
			];
			let structureAResults = this.calculateStructure(structs[0]);
			let structureBResults = this.calculateStructure(structs[1]);
			let structureCResults = this.calculateStructure(structs[2]);
			console.log(structureAResults, structureBResults, structureCResults);

			this.tanSolutionsStructures= [];
			this.tanSolutions = [];
			
			this.addStructureToSolutions(structureAResults, 'A');
			this.addStructureToSolutions(structureBResults, 'B');
			this.addStructureToSolutions(structureCResults, 'C');
		},
		addStructureToSolutions(results, structureType) {
			for(let i=0; i < results.length; i++) {
				results[i][1].tanResult = true;
				results[i][2].tanResult = true;
				results[i][3].tanResult = true;
				results[i][4].tanResult = true;
				let result = [results[i][1], results[i][2], results[i][3], results[i][4]];
				this.tanSolutions.push(result);
				this.tanSolutionsStructures.push(structureType);
			}
		},
		calculateStructure(structure) {
			let firstNode = this.tanSelectedChannels[0].quadrant;
			let secondNode = this.tanSelectedChannels[1].quadrant;
			
			let initialResult = {
				1: null,
				2: null,
				3: null,
				4: null,
				startNode: firstNode,
				previousNode: null,
				currentNode: null,
				nextNode: null
			}
			initialResult[firstNode] = this.tanSelectedChannels[0];
			initialResult[secondNode] = this.tanSelectedChannels[1];

			//CHECK IF INITIALS CHANNELS ARE POSSIBLE
			if(!this.checkResultIntegrity(initialResult, structure)) return [];
			
			console.log(initialResult, structure);
			let results = [];
			this.runAlgo(results, initialResult, structure);
			return results;
		},
		runAlgo(results, r, s) {
			console.log("RUN");
			while(r.currentNode != r.startNode) {
				console.log("CICLO");
				console.log(r.previousNode, r.currentNode);
				if(!r.currentNode) r.currentNode = r.startNode;

				let nextNode = s[r.currentNode].to[0].quadrant == r.previousNode ? s[r.currentNode].to[1] : s[r.currentNode].to[0];
				if(r[r.currentNode] && r[nextNode.quadrant]) {
					console.log("EXIST");
					if(!this.checkChannelsConnectivity(r[r.currentNode], r[nextNode.quadrant], nextNode.systems)) return false;
				} 
				else {
					let channelOptions = this.calculateConnectedChannels(r[r.currentNode], nextNode.systems, nextNode.quadrant);
					console.log(channelOptions);
					if(channelOptions.length == 0) return false;
					else {
						console.log("FORK");
						for(let i=0; i < channelOptions.length; i++) {
							let newResult = {
								1: r[1],
								2: r[2],
								3: r[3],
								4: r[4],
								startNode: r.startNode,
								previousNode: r.currentNode,
								currentNode: nextNode.quadrant,
								nextNode: r.nextNode
							}
							newResult[nextNode.quadrant] = channelOptions[i];
							this.runAlgo(results, newResult, s);
						}
						break;
					}
				}
				
				r.previousNode = r.currentNode;
				r.currentNode = nextNode.quadrant;
			}

			if(r.currentNode == r.startNode && r[1] && r[2] && r[3] && r[4]) results.push(r);
			return results;
		},
		checkResultIntegrity(r, s) {
			let previousNode = null;
			let currentNode = null;
			let nextNode = null;
			while(currentNode != r.startNode) {
				if(!currentNode) currentNode = r.startNode;
				
				nextNode = s[currentNode].to[0].quadrant == previousNode ? s[currentNode].to[1] : s[currentNode].to[0];
				
				if(r[currentNode] && r[nextNode.quadrant]) {
					if(!this.checkChannelsConnectivity(r[currentNode], r[nextNode.quadrant], nextNode.systems)) return false;
				}
				previousNode = currentNode;
				currentNode = nextNode.quadrant;
			}
			return true;
		},
		checkChannelsConnectivity(channel1, channel2, systems) {
			let channels = this.calculateConnectedChannels(channel1, systems, channel2.quadrant);
			//check if channel2 in channels
			for(let i=0; i < channels.length; i++) {
				if(channels[i].id == channel2.id && channels[i].position == channel2.position) return true;
			}
			return false;
		},
		calculateConnectedChannels(channel, systems, quadrant) {
			let channels = [];

			let contraLateral;
			if(channel.position == 'right') contraLateral = 'left';
			else contraLateral = 'right';

			for(let i=0; i < systems.length; i++) {
				let system = systems[i];
				let match = this.tanMatrix[channel.id];
				let systemMatchID = match[system - 1];
				let position;
				if(system == 2 || system == 4) position = 'bilateral';
				else position = contraLateral;
				let connectedChannels = this.getConnectedChannels(systemMatchID, channel.quadrant, channel.positive, position, quadrant);
				for(let ii=0; ii < connectedChannels.length; ii++) {
					if(!this.containsObject(connectedChannels[ii], channels)) channels.push(connectedChannels[ii]);
				}
			}
			return channels;
		},
		getConnectedChannels(id, currentQuadrant, currentPositive, position, quadrant) {
			let positive;
			if(Math.abs(currentQuadrant - quadrant) == 2) positive = currentPositive;
			else positive = !currentPositive;
			let channels = [];
			for(let i = 0; i < this.channelRows.length; i++) {
				for(let h = 0; h < this.channelRows[i].length; h++) {
					if(this.channelRows[i][h].id == id &&
						(this.channelRows[i][h].position == position || position == 'bilateral') &&
						this.channelRows[i][h].quadrant == quadrant &&
						this.channelRows[i][h].positive == positive) {
							channels.push(this.channelRows[i][h]);
					}
				}
			}
			return channels;
		},
		//MINIMAL CHANNEL RESULTS
		containsObject(obj, list) {
			var i;
			for (i = 0; i < list.length; i++) {
					if (list[i].id == obj.id && list[i].position == obj.position) {
							return true;
					}
			}
			return false;
		},
		channelInFilteredSolutions(channel) {
			for(let i = 0; i < this.tanSolutionsOrdered.length; i++) {
				if(this.containsObject(channel, this.tanSolutionsOrdered[i])) return true;
			}
			return false;
		},
		channelCoveredMinimal(channel, solutions) {
			for(let i = 0; i < solutions.length; i++) {
				if(this.containsObject(channel, solutions[i].tanCovers)) return true;
			}
			return false;
		},
		calculateMinimalChannelsResult(solutions, numCoveredChannels) {
			const numSelectedChannels = this.tanSelectedChannels.length;
			while(numSelectedChannels > numCoveredChannels) {
				let maxChannelsCovered = 0;
				let channelMostCovers = null;
				let channelsCovered;
				for(let i = 0; i < this.tanResultChannels.length; i++) {
					if(!this.tanResultChannels[i].tanSeletedResult) {
						channelsCovered = 0;
						for(let h = 0; h < this.tanResultChannels[i].tanCovers.length; h++) {
							if(!this.channelCovered(this.tanResultChannels[i].tanCovers[h])) {
								channelsCovered += 1;
							}
						}
						if(maxChannelsCovered < channelsCovered) {
							maxChannelsCovered = channelsCovered;
							channelMostCovers = this.tanResultChannels[i];
						}
					}
				}
				channelMostCovers.tanSeletedResult = true;
				numCoveredChannels += maxChannelsCovered;
			}
		},
		calculateMinimalChannelResults(solutions, numCoveredChannels) {
			const numSelectedChannels = this.tanSelectedChannels.length;
			while(numSelectedChannels > numCoveredChannels) {
				console.log("CICLO");
				let maxChannelsCovered = 0;
				let channelsMostCovers = [];
				let channelsCovered;
				for(let i = 0; i < this.tanResultChannels.length; i++) {
					if(!this.containsObject(this.tanResultChannels[i], solutions)) {
						channelsCovered = 0;
						for(let h = 0; h < this.tanResultChannels[i].tanCovers.length; h++) {
							if(!this.channelCoveredMinimal(this.tanResultChannels[i].tanCovers[h], solutions)) {
								channelsCovered += 1;
							}
						}
						console.log("CHANNELS COVERED", channelsCovered);
						if(maxChannelsCovered < channelsCovered) {
							console.log("É MAIOR");
							maxChannelsCovered = channelsCovered;
							channelsMostCovers = [this.tanResultChannels[i]];
						} else if(maxChannelsCovered == channelsCovered) {
							console.log("JÁ EXISTE");
							channelsMostCovers.push(this.tanResultChannels[i]);
						}
					}
				}
				console.log("MAX CHANNELS COVERED", maxChannelsCovered, channelsMostCovers);
				numCoveredChannels += maxChannelsCovered;
				
				console.log("NUM COVERED", numCoveredChannels);
				solutions.push(channelsMostCovers[0]);
				if(channelsMostCovers.length > 1) {
					console.log("MAIS CICLOS");
					for(let i = 1; i < channelsMostCovers.length; i++) {
						let s = [];
						let num = numCoveredChannels;
						let h = 0;
						for(h = 0; h < solutions.length - 1; h++) {
							s.push(solutions[h]);
						}
						s[h] = channelsMostCovers[i];
						this.calculateMinimalChannelResults(s, num);
					}
				}
			}
			console.log("finish");
			if(!this.solutionExist(solutions)) this.tanSolutions.push(solutions);
		},
		solutionExist(solution) {
			for(let i = 0; i < this.tanSolutions.length; i++) {
				if(this.tanSolutions[i].length == solution.length) {
					let equal = true;
					for(let h = 0; h < solution.length; h++) {
						if(!this.containsObject(solution[h], this.tanSolutions[i])) {
							equal = false;
							break;
						}
					}
					if(equal) return true;
				}
			}
			return false;
		},
		showSolution(solution) {
			if(this.tanResultSelectedChannels.length == 0) return true;
			for(let i = 0; i < this.tanResultSelectedChannels.length; i++) {
				if(!this.containsObject(this.tanResultSelectedChannels[i], solution)) return false;
			}
			return true
		},
		setSystemResult(channel, id, position) {
			for(let i = 0; i < this.channelRows.length; i++) {
				for(let h = 0; h < this.channelRows[i].length; h++) {
					if(this.channelRows[i][h].id == id) {
						if(this.channelRows[i][h].position == position || position == 'bilateral') {
								this.channelRows[i][h].tanResult += 1;
								let index = this.channelRows[i][h].tanCovers.findIndex(c => c.id == channel.id && c.position == channel.position);
								if(index == -1) this.channelRows[i][h].tanCovers.push(channel);
								let index2 = channel.tanCovered.findIndex(c => c.id == this.channelRows[i][h].id && c.position == this.channelRows[i][h].position);
								if(index2 == -1) channel.tanCovered.push(this.channelRows[i][h]);
						}
					}
				}
			}
		},
		setChannelResult(channel) {
			if(channel.id == 'ren') this.setSystemResult(channel, "du", "center");
			else if(channel.id == 'du') this.setSystemResult(channel, "ren", "center");
			else {
				let match = this.tanMatrix[channel.id];
				let contraLateral;
				if(channel.position == 'right') contraLateral = 'left';
				else contraLateral = 'right';
				if(this.selectedSystems.includes(1)) this.setSystemResult(channel, match[0], contraLateral);
				if(this.selectedSystems.includes(2)) this.setSystemResult(channel, match[1], 'bilateral');
				if(this.selectedSystems.includes(3)) this.setSystemResult(channel, match[2], contraLateral);
				if(this.selectedSystems.includes(4)) this.setSystemResult(channel, match[3], 'bilateral');
				if(this.selectedSystems.includes(5)) this.setSystemResult(channel, match[4], contraLateral);
			}
		},
		recalculateTanLocal() {
			this.resetResults();
			this.calculateTanLocal();
			let initialSolution = [];
			this.calculateMinimalChannelResults(initialSolution, 0);
		},
		nextStepTan() {
			this.channel = '';
			if(this.tanStep == 1) {
				this.resetResults();
				if(this.balanceType == 'local') {
					this.calculateTanLocal();
					let initialSolution = [];
					this.calculateMinimalChannelResults(initialSolution, 0);
				} else {
					this.calculateTanGlobal();
				}
				this.tanStep = 2;
			}
			else if (this.tanStep == 2) {
				this.tanStep = 3;
			}
			else if(this.tanStep == 3) {
				this.resetTan();
			}
		},
		overResultChannel(channel) {
			console.log(channel.tanCovers);
			for(let i = 0; i < channel.tanCovers.length; i++) {
				channel.tanCovers[i].highlight = true;
				console.log(channel.tanCovers[i]);
			}
		},
		leaveResultChannel(channel) {
			console.log(channel.tanCovers);
			for(let i = 0; i < channel.tanCovers.length; i++) {
				channel.tanCovers[i].highlight = false;
			}
		},
		clickResult(channel) {
			channel.tanSeletedResult = !channel.tanSeletedResult;
		},
		addResult(channels) {
			channels.forEach(channel => {
				channel.tanSeletedResult = true;
			});
		},
		getRomanNumber(n) {
			if(n == 1) return "I";
			if(n == 2) return "II";
			if(n == 3) return "III";
			if(n == 4) return "IV";
			if(n == 5) return "V";
		}
	},
  mounted() {
		this.appointmentAshiPoints = this.ashiPoints;
		this.$store.dispatch("GET_CUSTOM_GROUPS").then(() => {});
	},
	watch: {
		selectedTreatments(newList, oldList) {
			if(newList.length > oldList.length) this.aplyCustomGroup(newList[newList.length - 1]);
			else {
				for(let i = 0; i < oldList.length; i++) {
					let exist = false;
					for(let h = 0; h < newList.length; h++) {
						if(oldList[i] == newList[h]) exist = true;
					}
					if(!exist) {
						this.removeCustomGroup(oldList[i]);
						break;
					}
				}
			}
		},
		ashiPoints(value) {
			this.appointmentAshiPoints = value;
		},
		tourStep(value) {
			if(value == 'tour-acu-select') {
				let data = {
					appointment: this.$route.params.aid,
					op: "add_points",
					ids: ['lu-1R', 'pc-3L', 'liv-12R', 'sp-5L'],
					technics: this.pointTechnics
				}
				this.$store.dispatch("ADD_POINTS", data);
			}
		}
	}
};
</script>

<style scoped>
.tanSelected{
	box-shadow: 0px 3px 1px -2px #E57373, 0px 2px 2px 0px #E57373, 0px 1px 5px 0px #E57373 !important;
}
.tanSelectedComplete {
	box-shadow: 0px 3px 1px -2px green, 0px 2px 2px 0px green, 0px 1px 5px 0px green !important;
}
</style>